var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "group-travel-main full-height",
      staticStyle: { padding: "15px" },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "旅遊團公告設定",
            visible: _vm.dialogTravelBulletinBoardVisible,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTravelBulletinBoardVisible = $event
            },
            open: _vm.handleDialogOpen,
            close: _vm.handleClose,
          },
        },
        [
          _c("TravelBulletinBoard", {
            attrs: { travelId: _vm.selectedTravelID },
            on: {
              "on-save": _vm.handleBulletinSave,
              "on-delete": _vm.handleBulletinDelete,
            },
            model: {
              value: _vm.bulletinList,
              callback: function ($$v) {
                _vm.bulletinList = $$v
              },
              expression: "bulletinList",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "info" },
                  on: { click: _vm.closeDialogTravelBulletinBoardVisible },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "旅遊團日期登入",
            visible: _vm.dialogLoginDateVisible,
            width: "400px",
            "custom-class": "custom-dialog",
          },
          on: {
            open: _vm.doGetLoginDate,
            "update:visible": function ($event) {
              _vm.dialogLoginDateVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "日期登入設定",
                        "label-width": "100px",
                        prop: "bulletinBoard",
                      },
                    },
                    [
                      _c("el-switch", {
                        staticStyle: { display: "block" },
                        attrs: {
                          "active-color": "#409eff",
                          "inactive-color": "#ff4949",
                          "active-text": "開啟",
                          "inactive-text": "關閉",
                          "active-value": true,
                          "inactive-value": false,
                        },
                        model: {
                          value: _vm.formData.loginDateEnable,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "loginDateEnable", $$v)
                          },
                          expression: "formData.loginDateEnable",
                        },
                      }),
                      _c("hr"),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%", "font-size": "12px" },
                        attrs: {
                          disabled: _vm.formData.loginDateEnable === false,
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "選擇日期",
                        },
                        model: {
                          value: _vm.formData.loginDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "loginDate", $$v)
                          },
                          expression: "formData.loginDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "warning" },
                  on: { click: _vm.doSaveLoginDate },
                },
                [_vm._v(" 儲 存 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLoginDateVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            "modal-append-to-body": "",
            top: _vm.dialogTopMargin,
            title: "【" + _vm.travelName + " 】旅客查看說明會影片紀錄",
            visible: _vm.travelSeminarMovieEventVisible,
            width: "55%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.travelSeminarMovieEventVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card", staticStyle: { "overflow-y": "auto" } },
            [
              _c("div", { staticStyle: { "max-height": "450px" } }, [
                _c(
                  "div",
                  { staticStyle: { position: "relative", height: "100%" } },
                  [
                    _c(
                      "el-table",
                      {
                        attrs: {
                          size: "mini",
                          data: _vm.travelSeminarMovieEvent,
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                          height: "100%",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "項次",
                            width: "60",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "姓名" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s("" + scope.row.userName) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { align: "center", label: "明細" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s("" + scope.row.dateTime) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.travelSeminarMovieEventVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "選擇旅遊團建立模式",
            visible: _vm.dialogTravelChoiceVisible,
            width: "400px",
            "custom-class": "custom-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTravelChoiceVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "option-container" }, [
            _c(
              "div",
              {
                class: [
                  "option",
                  "manual",
                  { active: _vm.selectedTravelCreateMode === "manual" },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectOption("manual")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-edit" }),
                _c("span", [_vm._v("手動輸入")]),
              ]
            ),
            _c(
              "div",
              {
                class: [
                  "option",
                  "ai",
                  { active: _vm.selectedTravelCreateMode === "ai" },
                ],
                on: {
                  click: function ($event) {
                    return _vm.selectOption("ai")
                  },
                },
              },
              [
                _c("i", { staticClass: "el-icon-cpu" }),
                _c("span", [_vm._v("AI智能")]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            "modal-append-to-body": "",
            title:
              _vm.aiImportMode == "main" ? "活動建立AI匯入" : "行程資料AI匯入",
            visible: _vm.dialogTravelFormVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTravelFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "travelFormData",
              attrs: { model: _vm.travelFormData, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.checkPermission([
                          "ITA-DEV",
                          "APP-ADMIN",
                          "ITA-ADMIN",
                        ]) && _vm.aiImportMode == "main",
                      expression:
                        "checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN']) && aiImportMode == 'main'",
                    },
                  ],
                  staticStyle: { "margin-bottom": "14px" },
                  attrs: {
                    label: "旅行社名稱",
                    "label-width": _vm.formLabelWidth,
                    prop: "agencyCode",
                    rules: [
                      {
                        required:
                          _vm.checkPermission([
                            "ITA-DEV",
                            "APP-ADMIN",
                            "ITA-ADMIN",
                          ]) && _vm.aiImportMode == "main"
                            ? true
                            : false,
                        message: "請選擇旅行社名稱",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-full-select",
                      attrs: {
                        filterable: "",
                        placeholder: "請選擇",
                        disabled: _vm.agencyOptionDisabled,
                      },
                      model: {
                        value: _vm.travelFormData.agencyCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.travelFormData, "agencyCode", $$v)
                        },
                        expression: "travelFormData.agencyCode",
                      },
                    },
                    _vm._l(_vm.agencyList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.aiImportMode == "main",
                      expression: "aiImportMode == 'main'",
                    },
                  ],
                  attrs: {
                    label: "團號",
                    "label-width": _vm.formLabelWidth,
                    prop: "tourGroupNo",
                    rules: [
                      {
                        required: false,
                        message: "請輸入團號",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "tourGroupNoInput",
                    attrs: {
                      autocomplete: "off",
                      placeholder: "請輸入團號，保持空白則交由AI填寫",
                    },
                    model: {
                      value: _vm.travelFormData.tourGroupNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.travelFormData, "tourGroupNo", $$v)
                      },
                      expression: "travelFormData.tourGroupNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.aiImportMode == "main",
                      expression: "aiImportMode == 'main'",
                    },
                  ],
                  attrs: {
                    label: "團名",
                    "label-width": _vm.formLabelWidth,
                    prop: "travelName",
                    rules: [
                      {
                        required: false,
                        message: "請輸入團名",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      autocomplete: "off",
                      placeholder: "請輸入團名，保持空白則交由AI填寫",
                    },
                    model: {
                      value: _vm.travelFormData.travelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.travelFormData, "travelName", $$v)
                      },
                      expression: "travelFormData.travelName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.aiImportMode == "main",
                      expression: "aiImportMode == 'main'",
                    },
                  ],
                  attrs: {
                    label: "國家/區域",
                    "label-width": _vm.formLabelWidth,
                    prop: "countryAreaList",
                    rules: [
                      {
                        required: _vm.aiImportMode == "main",
                        message: "請選擇國家區域",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "popper-class": "travel-data-cascader",
                          clearable: "",
                          "collapse-tags": "",
                          props: {
                            multiple: true,
                            checkStrictly: false,
                            expandTrigger: "hover",
                          },
                          placeholder: "請選擇",
                          filterable: "",
                          options: _vm.travelAttractionsCascaderMenu,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.getPositionAndCouurncyByAIImport()
                          },
                        },
                        model: {
                          value: _vm.travelFormData.countryAreaList,
                          callback: function ($$v) {
                            _vm.$set(_vm.travelFormData, "countryAreaList", $$v)
                          },
                          expression: "travelFormData.countryAreaList",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "檔案",
                    rules: [
                      {
                        required: true,
                        message: "請上傳完整活動手冊PDF檔案",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("Upload", {
                    ref: "uploadRefTravel",
                    attrs: {
                      accept: ".pdf",
                      payload: _vm.travelFormData,
                      "data-obj": _vm.travelFileObj,
                      "limit-file-count": 1,
                      "show-limit": false,
                      "use-drag": false,
                      action: "TravelSettings/tourHandbook",
                      "auto-upload": false,
                      "show-file-list": true,
                      "form-on-loading-parent": _vm.formLoading,
                      "btn-txt": "上傳文件",
                      require: "",
                      prop: "file",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "22px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("請上傳完整活動手冊PDF檔案")]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "22px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("AI協助快速建立相關資訊")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "warning" },
                  on: { click: _vm.handleTravelInfoAnalyticsDailogSubmit },
                },
                [_vm._v("確 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.handleTravelInfoAnalyticsDailogCancel },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.currentLeaderRecordRow && _vm.currentLeaderRecordRow.loginTimes
        ? _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                title:
                  "【" +
                  _vm.currentLeaderRecordRow.userName +
                  "】登入/登出紀錄",
                visible: _vm.dialogLeaderLoginRecordVisible,
                width: "30%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogLeaderLoginRecordVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", [
                  _c(
                    "div",
                    { staticStyle: { position: "relative", height: "400px" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.listLoading,
                              expression: "listLoading",
                            },
                          ],
                          attrs: {
                            size: "mini",
                            data: _vm.currentLeaderRecordRow.loginTimes,
                            border: "",
                            fit: "",
                            "highlight-current-row": "",
                            height: "100%",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "項次",
                              width: "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4178052834
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "登入日期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.type == 1
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                effect: "plain",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    "" + scope.row.dateTime
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4044697736
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "登出日期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.type == 2
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                effect: "plain",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    "" + scope.row.dateTime
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2966066206
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogLeaderLoginRecordVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentTravelersRecordRow && _vm.currentTravelersRecordRow.loginTimes
        ? _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                title:
                  "【" + _vm.currentTravelersRecordRow.name + "】登入/登出紀錄",
                visible: _vm.dialogTravelersLoginRecordVisible,
                width: "30%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogTravelersLoginRecordVisible = $event
                },
              },
            },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", [
                  _c(
                    "div",
                    { staticStyle: { position: "relative", height: "400px" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.listLoading,
                              expression: "listLoading",
                            },
                          ],
                          attrs: {
                            size: "mini",
                            data: _vm.currentTravelersRecordRow.loginTimes,
                            border: "",
                            fit: "",
                            "highlight-current-row": "",
                            height: "100%",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "項次",
                              width: "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4178052834
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "登入日期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.type == 1
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                effect: "plain",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    "" + scope.row.dateTime
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4044697736
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "登出日期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.type == 2
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                effect: "plain",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    "" + scope.row.dateTime
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2966066206
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogTravelersLoginRecordVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            "modal-append-to-body": "",
            "append-to-body": "",
            visible: _vm.dialogPostitionSubVisible,
            title: "【" + _vm.formData.travelName + "】天氣地點顯示設定",
            top: "30vh",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPostitionSubVisible = $event
            },
          },
        },
        [
          _vm.positionMsg !== null
            ? _c("el-alert", {
                staticStyle: {
                  "background-color": "#ffd643",
                  color: "#4b4b4b",
                },
                attrs: {
                  title: _vm.positionMsg,
                  effect: "dark",
                  closable: false,
                },
              })
            : _vm._e(),
          _c(
            "div",
            [
              _vm.positionSubOptions
                ? _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%", "margin-top": "10px" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        placeholder: "請選擇地點",
                        disabled: _vm.permissionCheck(_vm.formData.status),
                      },
                      model: {
                        value: _vm.formData.position,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "position", $$v)
                        },
                        expression: "formData.position",
                      },
                    },
                    _vm._l(_vm.positionSubOptions, function (item) {
                      return _c("el-option", {
                        key: item.positionID,
                        attrs: {
                          label: item.country + "-" + item.city,
                          value: item.positionID,
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogPostitionSubVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.currentPositionData &&
      _vm.currentPositionData.records &&
      _vm.currentPositionData.records.length > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                title:
                  _vm.currentPlanningDescription !== ""
                    ? _vm.referenceDate +
                      " 定位足跡紀錄，\n行程說明：【" +
                      _vm.currentPlanningDescription +
                      "】"
                    : _vm.referenceDate + " 定位足跡紀錄",
                visible: _vm.positionDialogVisible,
                top: "2%",
                width: "70%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.positionDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    height: "100%",
                    padding: "8px 0px",
                  },
                },
                [
                  _c(
                    "el-alert",
                    { attrs: { type: "error", closable: false } },
                    [
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "line-height": "0",
                            "font-size": "15px",
                            "letter-spacing": "0.05em",
                          },
                        },
                        [_vm._v(" 可點選座標圖示查看旅行團當下數據資訊 ")]
                      ),
                    ]
                  ),
                  _vm.positionDialogVisible
                    ? _c("Map", {
                        attrs: { records: _vm.currentPositionData.records },
                      })
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.currentPositionData.records,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "300px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4178052834
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "日期", width: "90" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v(_vm._s(scope.row.date))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1531225394
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "left", label: "景點" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.viewPointName)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3218238656
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "集合時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.gatherAroundDate)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          538923388
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "到達時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.startTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3779423219
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "離開時間",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.leaveTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          824829608
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "停留時間",
                          width: "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.dwellTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          89793029
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "北緯", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.lat
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [_vm._v(_vm._s(scope.row.lat))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1203890484
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "東經", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.lng
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [_vm._v(_vm._s(scope.row.lng))]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3511418036
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "功能" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.lat && scope.row.lng
                                  ? [
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    icon: "el-icon-position",
                                                    type: "success",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.googleMap(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看Google地圖")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            "append-to-body": "",
            visible: _vm.dialoCurrencySubVisible,
            title: "【" + _vm.formData.travelName + "】貨幣設定",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialoCurrencySubVisible = $event
            },
          },
        },
        [
          _vm.currencyMsg
            ? _c("el-alert", {
                attrs: {
                  title: _vm.currencyMsg,
                  type: "warning",
                  effect: "dark",
                  closable: false,
                },
              })
            : _vm._e(),
          _vm.currencySubOptions
            ? _c(
                "el-select",
                {
                  staticStyle: { "margin-top": "10px", width: "100%" },
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "請選擇貨幣",
                  },
                  on: {
                    change: function ($event) {
                      _vm.dialoCurrencySubVisible = false
                    },
                  },
                  model: {
                    value: _vm.formData.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "currency", $$v)
                    },
                    expression: "formData.currency",
                  },
                },
                _vm._l(_vm.currencySubOptions, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: {
                      label: item.val + "-" + item.key,
                      value: item.key,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialoNetworkSettingLoading,
              expression: "dialoNetworkSettingLoading",
            },
          ],
          attrs: {
            width: "60%",
            "append-to-body": "",
            visible: _vm.dialoNetworkSettingVisible,
            title: "【" + _vm.travelName + "】網卡購買",
            top: "2%",
          },
          on: {
            open: _vm.getCurrentNetworkCardPostFee,
            "update:visible": function ($event) {
              _vm.dialoNetworkSettingVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("el-alert", {
                staticStyle: {
                  "background-color": "#ffd643",
                  color: "#4b4b4b",
                  "margin-bottom": "10px",
                },
                attrs: {
                  type: "info",
                  closable: false,
                  title:
                    "網卡購買將於出國前三天開始禁止下單及更改，以利廠商出貨作業",
                },
              }),
              _c(
                "el-row",
                { staticStyle: { "margin-bottom": "10px" } },
                [
                  _c("el-switch", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentNetworkStatus,
                        expression: "currentNetworkStatus",
                      },
                    ],
                    attrs: {
                      "active-text": "需要",
                      "inactive-text": "不需要",
                      "active-color": "#13ce66",
                      "inactive-color": "#ff4949",
                      "active-value": true,
                      "inactive-value": false,
                    },
                    model: {
                      value: _vm.selectedNetworkRow.networkCard,
                      callback: function ($$v) {
                        _vm.$set(_vm.selectedNetworkRow, "networkCard", $$v)
                      },
                      expression: "selectedNetworkRow.networkCard",
                    },
                  }),
                ],
                1
              ),
              _vm.selectedNetworkRow.networkCard
                ? _c(
                    "el-row",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "40%" },
                          attrs: {
                            disabled: !_vm.currentNetworkStatus,
                            size: "mini",
                            placeholder: "選擇網卡",
                          },
                          on: { change: _vm.selectedNetworkDesc },
                          model: {
                            value: _vm.selectedNetworkRow.cardID,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedNetworkRow, "cardID", $$v)
                            },
                            expression: "selectedNetworkRow.cardID",
                          },
                        },
                        _vm._l(
                          _vm.selectedNetworkRow.networkOptions,
                          function (item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: { label: item.val, value: item.key },
                            })
                          }
                        ),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "20%", "margin-left": "10px" },
                          attrs: {
                            disabled: !_vm.currentNetworkStatus,
                            size: "mini",
                            placeholder: "選擇數量",
                          },
                          model: {
                            value: _vm.selectedNetworkRow.cardCount,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedNetworkRow, "cardCount", $$v)
                            },
                            expression: "selectedNetworkRow.cardCount",
                          },
                        },
                        _vm._l(_vm.netWordcardDefaultOptions, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { size: "mini", type: "danger" },
                        },
                        [_vm._v("張")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                [
                  _vm.currentNetworkDesc
                    ? _c("el-col", { attrs: { span: 10 } }, [
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                rows: 20,
                                type: "textarea",
                              },
                              model: {
                                value: _vm.currentNetworkDesc,
                                callback: function ($$v) {
                                  _vm.currentNetworkDesc = $$v
                                },
                                expression: "currentNetworkDesc",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _c("el-col", { attrs: { span: 14 } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.selectedNetworkRow.networkCard,
                            expression: "selectedNetworkRow.networkCard",
                          },
                        ],
                        style: {
                          marginLeft: _vm.currentNetworkDesc ? "10px" : "0px",
                          padding: "6px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        },
                      },
                      [
                        _c("span", [_vm._v("網卡寄送方式")]),
                        _c(
                          "el-radio-group",
                          {
                            staticStyle: { "margin-top": "10px" },
                            model: {
                              value: _vm.selectedNetworkRow.postMode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.selectedNetworkRow,
                                  "postMode",
                                  $$v
                                )
                              },
                              expression: "selectedNetworkRow.postMode",
                            },
                          },
                          [
                            _c(
                              "el-radio",
                              {
                                staticStyle: { "margin-bottom": "20px" },
                                attrs: {
                                  label: 1,
                                  disabled: !_vm.currentNetworkStatus,
                                },
                              },
                              [
                                _vm._v(
                                  "寄送至貴公司，出國前1~2天送達，免運費（需下單至少10張即可免運） "
                                ),
                              ]
                            ),
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: 2,
                                  disabled: !_vm.currentNetworkStatus,
                                },
                              },
                              [
                                _vm._v(
                                  "前往本公司親自領取（高鐵桃園站前步行五分鐘）"
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentNetworkStatus,
                      expression: "currentNetworkStatus",
                    },
                  ],
                  staticStyle: { "margin-left": "5px", color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.saveTravelNetworkSetting },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: _vm.currentNetworkStatus ? "" : "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialoNetworkSettingVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.currentNetworkStatus ? "取消" : "關閉"))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            "append-to-body": "",
            visible: _vm.dialoCarryItemsReferenceVisible,
            "before-close": _vm.closeCarryReference,
            title:
              "【" +
              _vm.travelName +
              "】複製他團旅行" +
              (_vm.carryItemCopyType == 1 ? "建議物品" : "必帶物品"),
          },
          on: {
            opened: _vm.getAgencyTravelsAndOtherInformation,
            "update:visible": function ($event) {
              _vm.dialoCarryItemsReferenceVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "margin-bottom": "10px",
              },
            },
            [
              _c("label", { staticClass: "el-form-item__label" }, [
                _vm._v("旅遊團"),
              ]),
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.searchCarryItemsLoading,
                      expression: "searchCarryItemsLoading",
                    },
                  ],
                  staticStyle: { width: "60%", flex: "1" },
                  attrs: {
                    disabled:
                      _vm.searchCarryItemsLoading ||
                      _vm.carryCopySaving ||
                      _vm.carryItemsLoading,
                    clearable: "",
                    placeholder: "請選擇",
                    "value-key": "id",
                  },
                  model: {
                    value: _vm.selectedAgencyTravel,
                    callback: function ($$v) {
                      _vm.selectedAgencyTravel = $$v
                    },
                    expression: "selectedAgencyTravel",
                  },
                },
                _vm._l(
                  _vm.agencyTravels.filter(function (f) {
                    return f.id != _vm.selectedTravelID
                  }),
                  function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.travelName, value: item },
                    })
                  }
                ),
                1
              ),
              _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b", "margin-left": "5px" },
                  attrs: {
                    type: "warning",
                    disabled:
                      _vm.searchCarryItemsLoading ||
                      _vm.carryCopySaving ||
                      _vm.carryItemsLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doCopyCarryItems()
                    },
                  },
                },
                [_vm._v("儲存")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _vm.selectedAgencyTravel &&
              _vm.selectedAgencyTravel.travelResultCarryItems
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.searchCarryItemsLoading,
                          expression: "searchCarryItemsLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data:
                          _vm.carryItemCopyType === 1
                            ? _vm.selectedAgencyTravel.travelResultCarryItems
                                .recommended.items
                            : _vm.selectedAgencyTravel.travelResultCarryItems
                                .required.items,
                        border: "",
                        height: "500",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "項次", width: "50", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.$index + 1))]
                              },
                            },
                          ],
                          null,
                          false,
                          811300409
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "description",
                          label: "項目",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-tag", { attrs: { size: "mini" } }, [
                                    _vm._v(_vm._s(scope.row.description)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2502773584
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.carryItemsLoading,
              expression: "carryItemsLoading",
            },
          ],
          staticClass: "carryItem-dialog",
          attrs: {
            width: "80%",
            top: "2vh",
            visible: _vm.dialoCarryItemsVisible,
            "before-close": _vm.closeCarryItems,
            title: "【" + _vm.travelName + "】攜帶物品設定",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialoCarryItemsVisible = $event
            },
            opened: _vm.initCarrySortable,
          },
        },
        [
          _vm.carryItems
            ? _c(
                "el-tabs",
                {
                  staticStyle: { height: "100%" },
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.carryItemsTab,
                    callback: function ($$v) {
                      _vm.carryItemsTab = $$v
                    },
                    expression: "carryItemsTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "旅行必帶物品", name: "required" } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.permissionCheck(
                                            _vm.formData.status
                                          ),
                                          expression:
                                            "!permissionCheck(formData.status)",
                                        },
                                      ],
                                      staticStyle: { "margin-bottom": "10px" },
                                      attrs: {
                                        type: "success",
                                        disabled: _vm.carryCannotEdit(),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setCopyCarryItemType(2)
                                        },
                                      },
                                    },
                                    [_vm._v("複製他團旅行必帶物品")]
                                  ),
                                  _c(
                                    "el-form",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.permissionCheck(
                                            _vm.formData.status
                                          ),
                                          expression:
                                            "!permissionCheck(formData.status)",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "建議事項描述" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "請輸入建議事項描述",
                                              disabled: _vm.carryCannotEdit(),
                                            },
                                            model: {
                                              value:
                                                _vm.carryItems.required.remark,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.carryItems.required,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "carryItems.required.remark",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "新增項目" } },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                height: "auto",
                                                "white-space": "break-spaces",
                                                "font-size": "14px",
                                              },
                                              attrs: { type: "warning" },
                                            },
                                            [
                                              _vm._v(
                                                "使用符號 | 分隔可一次建立多筆資料。例：身分證|護照"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-input",
                                            {
                                              staticClass: "input-with-select",
                                              attrs: {
                                                placeholder: "請輸入項目",
                                                disabled: _vm.carryCannotEdit(),
                                              },
                                              model: {
                                                value:
                                                  _vm.newCarryItem.description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newCarryItem,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newCarryItem.description",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                staticStyle: {
                                                  "background-color": "#e6a23c",
                                                  "border-color": "#e6a23c",
                                                  color: "#ffffff",
                                                },
                                                attrs: {
                                                  slot: "append",
                                                  icon: "el-icon-plus",
                                                  disabled:
                                                    _vm.carryCannotEdit(),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addCarryItem(
                                                      "required"
                                                    )
                                                  },
                                                },
                                                slot: "append",
                                              }),
                                              _vm._v("新增 "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 14, offset: 1 } },
                                [
                                  !_vm.permissionCheck(_vm.formData.status)
                                    ? _c(
                                        "div",
                                        { staticClass: "carry-batch-toolbar" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              attrs: {
                                                type: "checkbox",
                                                disabled:
                                                  _vm.carryCannotEdit() ||
                                                  !_vm.carryItems.required.items
                                                    .length,
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.carryItems.required.items
                                                    .length > 0 &&
                                                  _vm.carrySelected.required
                                                    .length ===
                                                    _vm.carryItems.required
                                                      .items.length,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.selectAllCarryItems(
                                                    "required",
                                                    $event.target.checked
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" 全選必帶物品"),
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              "已選 " +
                                                _vm._s(
                                                  _vm.carrySelected.required
                                                    .length
                                                ) +
                                                " 項"
                                            ),
                                          ]),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                disabled:
                                                  _vm.carryCannotEdit() ||
                                                  !_vm.carrySelected.required
                                                    .length,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteSelectedCarryItems(
                                                    "required"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "刪除已選（" +
                                                  _vm._s(
                                                    _vm.carrySelected.required
                                                      .length
                                                  ) +
                                                  "）"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-table",
                                    {
                                      key: _vm.carryItemsTab,
                                      ref: "carryTable_required",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.carryItems.required.items,
                                        "row-key": function (row) {
                                          return row._carryKey
                                        },
                                        border: "",
                                      },
                                    },
                                    [
                                      !_vm.permissionCheck(_vm.formData.status)
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "選取",
                                              width: "65",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("input", {
                                                        attrs: {
                                                          type: "checkbox",
                                                          "aria-label":
                                                            "選取必帶物品 " +
                                                            scope.row
                                                              .description,
                                                          disabled:
                                                            _vm.carryCannotEdit(),
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.carrySelected.required.includes(
                                                              scope.row
                                                                ._carryKey
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleCarrySelection(
                                                              "required",
                                                              scope.row
                                                                ._carryKey,
                                                              $event.target
                                                                .checked
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2900287
                                            ),
                                          })
                                        : _vm._e(),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "項次",
                                          width: "50",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(scope.$index + 1)
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          811300409
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "description",
                                          label: "項目",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      size: "mini",
                                                      maxlength: "500",
                                                      disabled:
                                                        _vm.carryCannotEdit(),
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.description",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1287612113
                                        ),
                                      }),
                                      !_vm.permissionCheck(_vm.formData.status)
                                        ? _c("el-table-column", {
                                            attrs: {
                                              prop: "description",
                                              label: "排序",
                                              width: "160",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "carry-drag-handle",
                                                          attrs: {
                                                            type: "button",
                                                            "data-carry-key":
                                                              scope.row
                                                                ._carryKey,
                                                            "aria-label":
                                                              "拖曳排序必帶物品 " +
                                                              scope.row
                                                                .description +
                                                              "，目前第 " +
                                                              (scope.$index +
                                                                1) +
                                                              " 項",
                                                            disabled:
                                                              _vm.carryCannotEdit(),
                                                          },
                                                        },
                                                        [_vm._v("⋮⋮")]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            type: "button",
                                                            "aria-label":
                                                              "上移必帶物品 " +
                                                              scope.row
                                                                .description,
                                                            disabled:
                                                              _vm.carryCannotEdit() ||
                                                              scope.$index ===
                                                                0,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.moveCarryItem(
                                                                "required",
                                                                scope.$index,
                                                                scope.$index -
                                                                  1,
                                                                scope.row
                                                                  ._carryKey
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("↑")]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            type: "button",
                                                            "aria-label":
                                                              "下移必帶物品 " +
                                                              scope.row
                                                                .description,
                                                            disabled:
                                                              _vm.carryCannotEdit() ||
                                                              scope.$index ===
                                                                _vm.carryItems
                                                                  .required
                                                                  .items
                                                                  .length -
                                                                  1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.moveCarryItem(
                                                                "required",
                                                                scope.$index,
                                                                scope.$index +
                                                                  1,
                                                                scope.row
                                                                  ._carryKey
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("↓")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2240694618
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "旅行建議物品", name: "recommended" } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.permissionCheck(
                                            _vm.formData.status
                                          ),
                                          expression:
                                            "!permissionCheck(formData.status)",
                                        },
                                      ],
                                      staticStyle: { "margin-bottom": "10px" },
                                      attrs: {
                                        type: "success",
                                        disabled: _vm.carryCannotEdit(),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setCopyCarryItemType(1)
                                        },
                                      },
                                    },
                                    [_vm._v("複製他團旅行建議物品")]
                                  ),
                                  _c(
                                    "el-form",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.permissionCheck(
                                            _vm.formData.status
                                          ),
                                          expression:
                                            "!permissionCheck(formData.status)",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "建議事項描述" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "請輸入建議事項描述",
                                              disabled: _vm.carryCannotEdit(),
                                            },
                                            model: {
                                              value:
                                                _vm.carryItems.recommended
                                                  .remark,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.carryItems.recommended,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "carryItems.recommended.remark",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "新增項目" } },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                height: "auto",
                                                "white-space": "break-spaces",
                                                "font-size": "14px",
                                              },
                                              attrs: { type: "warning" },
                                            },
                                            [
                                              _vm._v(
                                                "使用符號 | 分隔可一次建立多筆資料。例：身分證|護照"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-input",
                                            {
                                              staticClass: "input-with-select",
                                              attrs: {
                                                placeholder: "請輸入項目",
                                                disabled: _vm.carryCannotEdit(),
                                              },
                                              model: {
                                                value:
                                                  _vm.newCarryItem.description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newCarryItem,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newCarryItem.description",
                                              },
                                            },
                                            [
                                              _c("el-button", {
                                                staticStyle: {
                                                  "background-color": "#e6a23c",
                                                  "border-color": "#e6a23c",
                                                  color: "#ffffff",
                                                },
                                                attrs: {
                                                  slot: "append",
                                                  icon: "el-icon-plus",
                                                  disabled:
                                                    _vm.carryCannotEdit(),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addCarryItem(
                                                      "recommended"
                                                    )
                                                  },
                                                },
                                                slot: "append",
                                              }),
                                              _vm._v("新增 "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 14, offset: 1 } },
                                [
                                  !_vm.permissionCheck(_vm.formData.status)
                                    ? _c(
                                        "div",
                                        { staticClass: "carry-batch-toolbar" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              attrs: {
                                                type: "checkbox",
                                                disabled:
                                                  _vm.carryCannotEdit() ||
                                                  !_vm.carryItems.recommended
                                                    .items.length,
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.carryItems.recommended
                                                    .items.length > 0 &&
                                                  _vm.carrySelected.recommended
                                                    .length ===
                                                    _vm.carryItems.recommended
                                                      .items.length,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.selectAllCarryItems(
                                                    "recommended",
                                                    $event.target.checked
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" 全選建議物品"),
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              "已選 " +
                                                _vm._s(
                                                  _vm.carrySelected.recommended
                                                    .length
                                                ) +
                                                " 項"
                                            ),
                                          ]),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                                disabled:
                                                  _vm.carryCannotEdit() ||
                                                  !_vm.carrySelected.recommended
                                                    .length,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteSelectedCarryItems(
                                                    "recommended"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "刪除已選（" +
                                                  _vm._s(
                                                    _vm.carrySelected
                                                      .recommended.length
                                                  ) +
                                                  "）"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-table",
                                    {
                                      key: _vm.carryItemsTab,
                                      ref: "carryTable_recommended",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: _vm.carryItems.recommended.items,
                                        "row-key": function (row) {
                                          return row._carryKey
                                        },
                                        border: "",
                                      },
                                    },
                                    [
                                      !_vm.permissionCheck(_vm.formData.status)
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "選取",
                                              width: "65",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("input", {
                                                        attrs: {
                                                          type: "checkbox",
                                                          "aria-label":
                                                            "選取建議物品 " +
                                                            scope.row
                                                              .description,
                                                          disabled:
                                                            _vm.carryCannotEdit(),
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.carrySelected.recommended.includes(
                                                              scope.row
                                                                ._carryKey
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleCarrySelection(
                                                              "recommended",
                                                              scope.row
                                                                ._carryKey,
                                                              $event.target
                                                                .checked
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              942054662
                                            ),
                                          })
                                        : _vm._e(),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "項次",
                                          width: "50",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    _vm._s(scope.$index + 1)
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          811300409
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "description",
                                          label: "項目",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      size: "mini",
                                                      maxlength: "500",
                                                      disabled:
                                                        _vm.carryCannotEdit(),
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.description",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1287612113
                                        ),
                                      }),
                                      !_vm.permissionCheck(_vm.formData.status)
                                        ? _c("el-table-column", {
                                            attrs: {
                                              prop: "description",
                                              label: "排序",
                                              width: "160",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "carry-drag-handle",
                                                          attrs: {
                                                            type: "button",
                                                            "data-carry-key":
                                                              scope.row
                                                                ._carryKey,
                                                            "aria-label":
                                                              "拖曳排序建議物品 " +
                                                              scope.row
                                                                .description +
                                                              "，目前第 " +
                                                              (scope.$index +
                                                                1) +
                                                              " 項",
                                                            disabled:
                                                              _vm.carryCannotEdit(),
                                                          },
                                                        },
                                                        [_vm._v("⋮⋮")]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            type: "button",
                                                            "aria-label":
                                                              "上移建議物品 " +
                                                              scope.row
                                                                .description,
                                                            disabled:
                                                              _vm.carryCannotEdit() ||
                                                              scope.$index ===
                                                                0,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.moveCarryItem(
                                                                "recommended",
                                                                scope.$index,
                                                                scope.$index -
                                                                  1,
                                                                scope.row
                                                                  ._carryKey
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("↑")]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            type: "button",
                                                            "aria-label":
                                                              "下移建議物品 " +
                                                              scope.row
                                                                .description,
                                                            disabled:
                                                              _vm.carryCannotEdit() ||
                                                              scope.$index ===
                                                                _vm.carryItems
                                                                  .recommended
                                                                  .items
                                                                  .length -
                                                                  1,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.moveCarryItem(
                                                                "recommended",
                                                                scope.$index,
                                                                scope.$index +
                                                                  1,
                                                                scope.row
                                                                  ._carryKey
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("↓")]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1889722943
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.permissionCheck(_vm.formData.status),
                      expression: "!permissionCheck(formData.status)",
                    },
                  ],
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { disabled: _vm.carryCannotEdit(), type: "warning" },
                  on: { click: _vm.settingCarryItems },
                },
                [_vm._v(" 儲 存 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.carryItemsLoading || _vm.carryCopySaving,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.closeCarryItems()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "seat-dialog",
            width: "80%",
            top: "0.3%",
            visible: _vm.dialoSeatFormsVisible,
            title: "【" + _vm.travelName + "】座位設定",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialoSeatFormsVisible = $event
            },
          },
        },
        [
          !_vm.seatType || _vm.seatType == 1
            ? _c("seat", {
                attrs: {
                  isCanSave: !_vm.permissionCheck(_vm.formData.status),
                  isRefresh: _vm.isRefreshSeat,
                  fatherDialogFormVisible: _vm.fatherDialogSeatFormVisible,
                  callback: _vm.seatCallback,
                  travelID: _vm.selectedTravelID,
                },
              })
            : _vm._e(),
          _vm.seatType == 2
            ? _c("seat-second", {
                attrs: {
                  isCanSave: !_vm.permissionCheck(_vm.formData.status),
                  isRefresh: _vm.isRefreshSeat,
                  fatherDialogFormVisible: _vm.fatherDialogSeatFormVisible,
                  callback: _vm.seatCallback,
                  travelID: _vm.selectedTravelID,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "editForm",
          staticStyle: { border: "2px solid #ccc" },
          attrs: {
            title: _vm.formData.id
              ? "維護旅遊資料 【紀錄保留至 " + _vm.formData.dataLimitInfo + "】"
              : "維護旅遊資料",
            visible: _vm.dialogFormVisible,
            width: "100%",
            fullscreen: "",
          },
          on: {
            closed: _vm.onDialogClosed,
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.formLoading,
                  expression: "formLoading",
                },
              ],
              staticClass: "box-card",
              attrs: { "body-style": { border: "1px solid #ccc" } },
            },
            [
              _c(
                "el-form",
                {
                  ref: "dynamicValidateForm",
                  attrs: {
                    model: _vm.formData,
                    disabled: _vm.permissionCheck(_vm.formData.status),
                    "label-position": "right",
                  },
                },
                [
                  _c("div", { staticClass: "edit-travel" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "團號",
                              "label-width": _vm.formLabelWidth,
                              prop: "tourGroupNo",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入團號",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              staticClass: "tourGroupNoInput",
                              attrs: {
                                disabled: !_vm.isAdd && !_vm.modifyTourNo,
                                autocomplete: "off",
                                placeholder: "請輸入團號",
                              },
                              model: {
                                value: _vm.formData.tourGroupNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "tourGroupNo", $$v)
                                },
                                expression: "formData.tourGroupNo",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "團名",
                              "label-width": _vm.formLabelWidth,
                              prop: "travelName",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入團名",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                autocomplete: "off",
                                placeholder: "請輸入團名",
                              },
                              model: {
                                value: _vm.formData.travelName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "travelName", $$v)
                                },
                                expression: "formData.travelName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.checkPermission([
                                  "ITA-DEV",
                                  "APP-ADMIN",
                                  "ITA-ADMIN",
                                ]),
                                expression:
                                  "checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])",
                              },
                            ],
                            attrs: {
                              label: "旅行社名稱",
                              "label-width": _vm.formLabelWidth,
                              prop: "agencyCode",
                              rules: [
                                {
                                  required: _vm.checkPermission([
                                    "ITA-DEV",
                                    "APP-ADMIN",
                                    "ITA-ADMIN",
                                  ])
                                    ? true
                                    : false,
                                  message: "請選擇旅行社名稱",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-full-select",
                                attrs: {
                                  filterable: "",
                                  placeholder: "請選擇",
                                  disabled: _vm.agencyOptionDisabled,
                                },
                                model: {
                                  value: _vm.formData.agencyCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "agencyCode", $$v)
                                  },
                                  expression: "formData.agencyCode",
                                },
                              },
                              _vm._l(_vm.agencyList, function (item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.val, value: item.key },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "旅遊性質",
                              "label-width": _vm.formLabelWidth,
                              prop: "travelProperty",
                              rules: [
                                {
                                  required: true,
                                  message: "請選擇旅遊性質",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-full-select",
                                attrs: {
                                  filterable: "",
                                  placeholder: "請選擇",
                                },
                                model: {
                                  value: _vm.formData.travelProperty,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "travelProperty",
                                      $$v
                                    )
                                  },
                                  expression: "formData.travelProperty",
                                },
                              },
                              _vm._l(_vm.travelPropertyOption, function (item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.label, value: item.key },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "團體類別",
                              "label-width": _vm.formLabelWidth,
                              prop: "travelAttributes",
                              rules: [
                                {
                                  required: true,
                                  message: "請選擇旅遊屬性",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "w-full-select",
                                attrs: {
                                  filterable: "",
                                  placeholder: "請選擇",
                                },
                                on: { change: _vm.chkTravelAttributesOption },
                                model: {
                                  value: _vm.formData.travelAttributes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "travelAttributes",
                                      $$v
                                    )
                                  },
                                  expression: "formData.travelAttributes",
                                },
                              },
                              _vm._l(
                                _vm.travelAttributesOption,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "國家/區域",
                              "label-width": _vm.formLabelWidth,
                              prop: "countryAreaList",
                              rules: [
                                {
                                  required: true,
                                  message: "請選擇國家區域",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "block" },
                              [
                                _c("el-cascader", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled:
                                      _vm.formData.travelAttributes == 1,
                                    "popper-class": "travel-data-cascader",
                                    clearable: "",
                                    "collapse-tags": "",
                                    props: {
                                      multiple: true,
                                      checkStrictly: false,
                                      expandTrigger: "hover",
                                    },
                                    placeholder: "請選擇",
                                    filterable: "",
                                    options: _vm.travelAttractionsCascaderMenu,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getPositionAndCouurncy()
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.countryAreaList,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "countryAreaList",
                                        $$v
                                      )
                                    },
                                    expression: "formData.countryAreaList",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "貨幣",
                              "label-width": _vm.formLabelWidth,
                              prop: "currency",
                              rules: [
                                {
                                  required: true,
                                  message: "請選擇旅遊貨幣",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "請選擇",
                                  disabled:
                                    _vm.formData.travelAttributes == 1 ||
                                    _vm.formData.travelAttributes == 3,
                                },
                                model: {
                                  value: _vm.formData.currency,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "currency", $$v)
                                  },
                                  expression: "formData.currency",
                                },
                              },
                              _vm._l(_vm.currencyOptions, function (item) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: {
                                    label: item.val + "-" + item.key,
                                    value: item.key,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm.currencySubOptions.length > 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialoCurrencySubVisible = true
                                      },
                                    },
                                  },
                                  [_vm._v("區域貨幣選單")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "其他設定",
                              "label-width": _vm.formLabelWidth,
                              prop: "showTravelInfo",
                            },
                          },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline other-setting",
                                attrs: { inline: true },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      border: "1px solid #ccc",
                                      padding: "5px",
                                      "border-radius": "4px",
                                    },
                                    attrs: { label: "顯示資訊" },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content:
                                            "是否需要顯示旅行社名稱以及圖片至App",
                                          placement: "bottom",
                                          effect: "light",
                                        },
                                      },
                                      [
                                        _c("el-switch", {
                                          attrs: {
                                            "active-color": "#13ce66",
                                            disabled: _vm.permissionCheck(
                                              _vm.formData.status
                                            ),
                                            "inactive-color": "#ccc",
                                            "active-text": "顯示",
                                            "inactive-text": "隱藏",
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          model: {
                                            value: _vm.formData.showTravelInfo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "showTravelInfo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.showTravelInfo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.formData
                                  ? _c(
                                      "el-form-item",
                                      {
                                        staticStyle: {
                                          border: "1px solid #ccc",
                                          padding: "5px",
                                          "border-radius": "4px",
                                        },
                                        attrs: { label: "旅遊天氣設定" },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                            on: { click: _vm.showPosition },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                !_vm.permissionCheck(
                                                  _vm.formData.status
                                                )
                                                  ? "設定"
                                                  : "查看"
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.formData.outfitImageUrl
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "center",
                                              height: "49px",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                height: "40px",
                                                cursor: "pointer",
                                              },
                                              attrs: {
                                                src: require("@/assets/images/icons8-t-shirt-100.png"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.outfitImageDialogVisible = true
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "去程班機",
                                      "label-width": _vm.formLabelWidth,
                                    },
                                  },
                                  _vm._l(
                                    _vm.formData.flightGoInfo,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "go-" + index,
                                          staticStyle: {
                                            display: "flex",
                                            gap: "10px",
                                            "margin-bottom": "15px",
                                            "align-items": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "1.5",
                                              },
                                              attrs: {
                                                prop:
                                                  "flightGoInfo." +
                                                  index +
                                                  ".date",
                                                rules: _vm.getFlightRules(
                                                  item,
                                                  index,
                                                  "date"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  placeholder: "選擇日期",
                                                  "value-format": "yyyy-MM-dd",
                                                },
                                                model: {
                                                  value: item.date,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "date", $$v)
                                                  },
                                                  expression: "item.date",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "2",
                                              },
                                              attrs: {
                                                prop:
                                                  "flightGoInfo." +
                                                  index +
                                                  ".number",
                                                rules: _vm.getFlightRules(
                                                  item,
                                                  index,
                                                  "number"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  autocomplete: "off",
                                                  placeholder: "例:CI160",
                                                },
                                                model: {
                                                  value: item.number,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "number",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.number",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "1.5",
                                              },
                                              attrs: {
                                                prop:
                                                  "flightGoInfo." +
                                                  index +
                                                  ".name",
                                                rules: _vm.getFlightRules(
                                                  item,
                                                  index,
                                                  "name"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  autocomplete: "off",
                                                  placeholder: "例:中華航空",
                                                },
                                                model: {
                                                  value: item.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "name", $$v)
                                                  },
                                                  expression: "item.name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "2",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                  },
                                                },
                                                [
                                                  index == 0 &&
                                                  !_vm.permissionCheck(
                                                    _vm.formData.status
                                                  )
                                                    ? _c("el-button", {
                                                        staticStyle: {
                                                          "margin-left":
                                                            "0.25rem",
                                                          padding: "9px",
                                                        },
                                                        attrs: {
                                                          type: "success",
                                                          icon: "el-icon-plus",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.addFlightField(
                                                              "flightGoInfo",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  index > 0
                                                    ? _c("el-button", {
                                                        staticStyle: {
                                                          "margin-left":
                                                            "0.25rem",
                                                          padding: "9px",
                                                        },
                                                        attrs: {
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeFlightField(
                                                              "flightGoInfo",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.validateFlightText(
                                                    item.number
                                                  )
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            padding: "0 0.5rem",
                                                            color: "#1890ff",
                                                            "white-space":
                                                              "nowrap",
                                                          },
                                                          attrs: {
                                                            href:
                                                              "https://www.bing.com/search?q=" +
                                                              item.number,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            attrs: {
                                                              "icon-class":
                                                                "link2",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "回程班機",
                                      "label-width": _vm.formLabelWidth,
                                    },
                                  },
                                  _vm._l(
                                    _vm.formData.flightReturnInfo,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "return-" + index,
                                          staticStyle: {
                                            display: "flex",
                                            gap: "10px",
                                            "margin-bottom": "15px",
                                            "align-items": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "1.5",
                                              },
                                              attrs: {
                                                prop:
                                                  "flightReturnInfo." +
                                                  index +
                                                  ".date",
                                                rules: _vm.getFlightRules(
                                                  item,
                                                  index,
                                                  "date"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  type: "date",
                                                  placeholder: "選擇日期",
                                                  "value-format": "yyyy-MM-dd",
                                                },
                                                model: {
                                                  value: item.date,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "date", $$v)
                                                  },
                                                  expression: "item.date",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "2",
                                              },
                                              attrs: {
                                                prop:
                                                  "flightReturnInfo." +
                                                  index +
                                                  ".number",
                                                rules: _vm.getFlightRules(
                                                  item,
                                                  index,
                                                  "number"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  autocomplete: "off",
                                                  placeholder: "例:CI160",
                                                },
                                                model: {
                                                  value: item.number,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "number",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.number",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "1.5",
                                              },
                                              attrs: {
                                                prop:
                                                  "flightReturnInfo." +
                                                  index +
                                                  ".name",
                                                rules: _vm.getFlightRules(
                                                  item,
                                                  index,
                                                  "name"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  autocomplete: "off",
                                                  placeholder: "例:中華航空",
                                                },
                                                model: {
                                                  value: item.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "name", $$v)
                                                  },
                                                  expression: "item.name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "0",
                                                flex: "2",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                  },
                                                },
                                                [
                                                  index == 0 &&
                                                  !_vm.permissionCheck(
                                                    _vm.formData.status
                                                  )
                                                    ? _c("el-button", {
                                                        staticStyle: {
                                                          "margin-left":
                                                            "0.25rem",
                                                          padding: "9px",
                                                        },
                                                        attrs: {
                                                          type: "success",
                                                          icon: "el-icon-plus",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.addFlightField(
                                                              "flightReturnInfo",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  index > 0
                                                    ? _c("el-button", {
                                                        staticStyle: {
                                                          "margin-left":
                                                            "0.25rem",
                                                          padding: "9px",
                                                        },
                                                        attrs: {
                                                          type: "danger",
                                                          icon: "el-icon-delete",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeFlightField(
                                                              "flightReturnInfo",
                                                              index
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.validateFlightText(
                                                    item.number
                                                  )
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticStyle: {
                                                            padding: "0 0.5rem",
                                                            color: "#1890ff",
                                                            "white-space":
                                                              "nowrap",
                                                          },
                                                          attrs: {
                                                            href:
                                                              "https://www.bing.com/search?q=" +
                                                              item.number,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            attrs: {
                                                              "icon-class":
                                                                "link2",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24, lg: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "遊覽車",
                                      "label-width": _vm.formLabelWidth,
                                      prop: "tourBusInfo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        autocomplete: "off",
                                        placeholder: "請輸入車牌號碼",
                                      },
                                      model: {
                                        value: _vm.formData.tourBusInfo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "tourBusInfo",
                                            $$v
                                          )
                                        },
                                        expression: "formData.tourBusInfo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 24, lg: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "集合地點",
                                      "label-width": _vm.formLabelWidth,
                                      prop: "gatherAroundLocation",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              placeholder: "請點擊選擇地點",
                                              readonly: "",
                                              clearable: "",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.openMapDialog($event)
                                              },
                                            },
                                            model: {
                                              value: _vm.displayLocationText,
                                              callback: function ($$v) {
                                                _vm.displayLocationText = $$v
                                              },
                                              expression: "displayLocationText",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              staticStyle: { padding: "10px" },
                                              attrs: {
                                                slot: "append",
                                                type: "default",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.handleClearLocation(
                                                    $event
                                                  )
                                                },
                                              },
                                              slot: "append",
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dialog",
                                      {
                                        attrs: {
                                          title: "選擇地點",
                                          visible: _vm.mapDialogVisible,
                                          width: "60%",
                                          "before-close": _vm.handleMapClose,
                                          "append-to-body": "",
                                          "close-on-click-modal": false,
                                          "close-on-press-escape": false,
                                        },
                                        on: {
                                          "update:visible": function ($event) {
                                            _vm.mapDialogVisible = $event
                                          },
                                          opened: _vm.initGatherGoogleMap,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                id: "pac-input",
                                                placeholder:
                                                  "請輸入地址、店名或大地標進行搜尋...",
                                                clearable: "",
                                                "prefix-icon": "el-icon-search",
                                              },
                                              model: {
                                                value: _vm.searchQuery,
                                                callback: function ($$v) {
                                                  _vm.searchQuery = $$v
                                                },
                                                expression: "searchQuery",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "400px",
                                          },
                                          attrs: { id: "map-canvas" },
                                        }),
                                        _vm.tempMapLocation
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "15px",
                                                  padding: "10px",
                                                  "background-color": "#f5f7fa",
                                                  "border-radius": "4px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      margin: "0",
                                                    },
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v("目前選取："),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.tempMapLocation
                                                            .name
                                                        ) +
                                                        " (" +
                                                        _vm._s(
                                                          _vm.tempMapLocation
                                                            .lng
                                                        ) +
                                                        ", " +
                                                        _vm._s(
                                                          _vm.tempMapLocation
                                                            .lat
                                                        ) +
                                                        ") "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "dialog-footer",
                                            attrs: { slot: "footer" },
                                            slot: "footer",
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                on: {
                                                  click: _vm.handleMapCancel,
                                                },
                                              },
                                              [_vm._v("取 消")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  disabled:
                                                    !_vm.tempMapLocation,
                                                },
                                                on: {
                                                  click: _vm.handleMapSave,
                                                },
                                              },
                                              [_vm._v("確 認")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "travel-time",
                            staticStyle: { bottom: "0px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  border: "solid 1px #ccc",
                                  padding: "5px",
                                  "background-color": "azure",
                                },
                                attrs: {
                                  label: "行程開始",
                                  "label-width": "100px",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 24,
                                          lg: 24,
                                          xl: 13,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "beginDate",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇行程開始日期",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px 0",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("行程開始日期"),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isAdd &&
                                                              !_vm.checkPermission(
                                                                [
                                                                  "ITA-DEV",
                                                                  "ITA-ADMIN",
                                                                  "ITA-ADM-STAFF",
                                                                  "SERVICE-ADMIN",
                                                                  "ITA-SER-STAFF",
                                                                  "ITA-SER-STAFF-GROUP",
                                                                  "ITA-SALES",
                                                                ]
                                                              ),
                                                            clearable: false,
                                                            type: "date",
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            placeholder:
                                                              "選擇日期",
                                                            "picker-options":
                                                              _vm.pickerBeginDateLimitOptions,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.checkDefault(
                                                                $event,
                                                                "departureDate"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .beginDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "beginDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.beginDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 24,
                                          lg: 24,
                                          xl: 11,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "beginTime",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇集合出發時間",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px 0",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("集合出發時間"),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-time-select", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            clearable: false,
                                                            "picker-options": {
                                                              start: "00:00",
                                                              step: "00:15",
                                                              end: "23:45",
                                                            },
                                                            placeholder:
                                                              "選擇時間",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.checkDefault(
                                                                $event,
                                                                "departureTime"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .beginTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "beginTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.beginTime",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false",
                                          },
                                        ],
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 12,
                                          lg: 12,
                                          xl: 6,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "departureDate",
                                              rules: [
                                                {
                                                  required:
                                                    !_vm.formData.countryAreaList.some(
                                                      function (x) {
                                                        return x == "region_10"
                                                      }
                                                    )
                                                      ? true
                                                      : false,
                                                  message: "請輸入班機出發日期",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#712cf9",
                                                        },
                                                      },
                                                      [_vm._v("班機出發日期")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            type: "date",
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            placeholder:
                                                              "選擇日期",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .departureDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "departureDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.departureDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false",
                                          },
                                        ],
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 12,
                                          lg: 12,
                                          xl: 6,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "departureTime",
                                              rules: [
                                                {
                                                  required:
                                                    !_vm.formData.countryAreaList.some(
                                                      function (x) {
                                                        return x == "region_10"
                                                      }
                                                    )
                                                      ? true
                                                      : false,
                                                  message: "請輸入班機出發時間",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#712cf9",
                                                        },
                                                      },
                                                      [_vm._v("班機出發時間")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-time-select", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            "picker-options": {
                                                              start: "00:00",
                                                              step: "00:15",
                                                              end: "23:45",
                                                            },
                                                            placeholder:
                                                              "選擇時間",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .departureTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "departureTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.departureTime",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  border: "solid 1px #ccc",
                                  padding: "5px",
                                  "background-color": "antiquewhite",
                                },
                                attrs: {
                                  label: "行程結束",
                                  "label-width": "100px",
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 24,
                                          lg: 24,
                                          xl: 13,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "endDate",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇行程結束日期",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px 0",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("行程結束日期"),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isAdd &&
                                                              !_vm.checkPermission(
                                                                [
                                                                  "ITA-DEV",
                                                                  "ITA-ADMIN",
                                                                  "ITA-ADM-STAFF",
                                                                  "SERVICE-ADMIN",
                                                                  "ITA-SER-STAFF",
                                                                  "ITA-SER-STAFF-GROUP",
                                                                  "ITA-SALES",
                                                                ]
                                                              ),
                                                            clearable: false,
                                                            "picker-options":
                                                              _vm.pickerLimitOptions,
                                                            type: "date",
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            placeholder:
                                                              "選擇日期",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.checkDefault(
                                                                $event,
                                                                "returnDate"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .endDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "endDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.endDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 24,
                                          lg: 24,
                                          xl: 11,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "endTime",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇行程結束時間",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px 0",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("行程結束時間"),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-time-select", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            clearable: false,
                                                            "picker-options": {
                                                              start: "00:00",
                                                              step: "00:15",
                                                              end: "23:45",
                                                            },
                                                            placeholder:
                                                              "選擇時間",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.checkDefault(
                                                                $event,
                                                                "returnTime"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .endTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "endTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.endTime",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false",
                                          },
                                        ],
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 12,
                                          lg: 12,
                                          xl: 6,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "returnDate",
                                              rules: [
                                                {
                                                  required:
                                                    !_vm.formData.countryAreaList.some(
                                                      function (x) {
                                                        return x == "region_10"
                                                      }
                                                    )
                                                      ? true
                                                      : false,
                                                  message: "請輸入班機回程日期",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#712cf9",
                                                        },
                                                      },
                                                      [_vm._v("班機回程日期")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            "picker-options":
                                                              _vm.pickerFlightLimitOptions,
                                                            type: "date",
                                                            "value-format":
                                                              "yyyy-MM-dd",
                                                            placeholder:
                                                              "選擇日期",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .returnDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "returnDate",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.returnDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false",
                                          },
                                        ],
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 12,
                                          lg: 12,
                                          xl: 6,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "returnTime",
                                              rules: [
                                                {
                                                  required:
                                                    !_vm.formData.countryAreaList.some(
                                                      function (x) {
                                                        return x == "region_10"
                                                      }
                                                    )
                                                      ? true
                                                      : false,
                                                  message: "請輸入班機回程時間",
                                                  trigger: "blur",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-card",
                                              {
                                                attrs: {
                                                  "body-style": {
                                                    padding: "0px",
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      padding: "14px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#712cf9",
                                                        },
                                                      },
                                                      [_vm._v("班機回程時間")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "bottom clearfix",
                                                      },
                                                      [
                                                        _c("el-time-select", {
                                                          staticStyle: {
                                                            width: "100%",
                                                            "font-size": "12px",
                                                          },
                                                          attrs: {
                                                            "picker-options": {
                                                              start: "00:00",
                                                              step: "00:15",
                                                              end: "23:45",
                                                            },
                                                            placeholder:
                                                              "選擇時間",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.formData
                                                                .returnTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.formData,
                                                                "returnTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "formData.returnTime",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "領隊公告",
                              "label-width": "100px",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  [
                                    _vm.selectedTravelID
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: { disabled: false },
                                            on: {
                                              click: function ($event) {
                                                _vm.dialogTravelBulletinBoardVisible = true
                                              },
                                            },
                                          },
                                          [_vm._v("公告設定")]
                                        )
                                      : _c("el-tag", [
                                          _vm._v("請先儲存才可建立公告 "),
                                        ]),
                                  ],
                                  1
                                ),
                                _c("el-row", [
                                  _c(
                                    "div",
                                    [
                                      _c("UploadCustom", {
                                        ref: "uploadBoardRef",
                                        attrs: {
                                          span: 24,
                                          btnStyle: "primary",
                                          accept: ".jpg,.jpeg,.bmp,.png",
                                          payload: _vm.boardFileModel,
                                          "data-obj": _vm.fileObj,
                                          "limit-file-count": 50,
                                          limitText:
                                            "圖片須為.jpg,.png,.bmp格式，限制不超過200MB",
                                          "use-drag": false,
                                          action:
                                            "TravelSettings/bulletinBoard",
                                          "auto-upload": false,
                                          "show-file-list": true,
                                          "form-on-loading-parent":
                                            _vm.formLoading,
                                          "btn-txt": "上傳",
                                          "before-file-list":
                                            _vm.formData.bulletinBoardData &&
                                            _vm.formData.bulletinBoardData
                                              .fileInfo &&
                                            _vm.formData.bulletinBoardData
                                              .fileInfo.length
                                              ? _vm.formData.bulletinBoardData
                                                  .fileInfo[0].files
                                              : [],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "說明會影片",
                              "label-width": "100px",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          height: "auto",
                                          "white-space": "break-spaces",
                                          "font-size": "14px",
                                        },
                                        attrs: { type: "success" },
                                      },
                                      [
                                        _vm._v(
                                          "說明會影片僅限使用【上傳影片】或貼上【影片連結】其中一種方式使用"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("el-switch", {
                                  staticStyle: { display: "block" },
                                  attrs: {
                                    "active-color": "#409eff",
                                    "inactive-color": "#409eff",
                                    "active-text": "影片連結",
                                    "inactive-text": "上傳影片",
                                    "active-value": 2,
                                    "inactive-value": 1,
                                  },
                                  model: {
                                    value: _vm.formData.seminarMovieKind,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "seminarMovieKind",
                                        $$v
                                      )
                                    },
                                    expression: "formData.seminarMovieKind",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.formData.seminarMovieKind == 1,
                                        expression:
                                          "formData.seminarMovieKind == 1",
                                      },
                                    ],
                                  },
                                  [
                                    _c("UploadCustom", {
                                      ref: "uploadRef",
                                      attrs: {
                                        btnStyle: "primary",
                                        accept: ".mp4",
                                        payload: _vm.formData,
                                        span: 24,
                                        "data-obj": _vm.fileObj,
                                        "limit-file-count": 1,
                                        limitText:
                                          "影片須為.mp4格式，限制不超過2000MB",
                                        "use-drag": false,
                                        action: "TravelSettings/saveGroupTour",
                                        "auto-upload": false,
                                        "show-file-list": true,
                                        "form-on-loading-parent":
                                          _vm.formLoading,
                                        "btn-txt": "上傳",
                                        "before-file-list":
                                          _vm.formData.fileInfo &&
                                          _vm.formData.fileInfo.length
                                            ? _vm.formData.fileInfo[0].files
                                            : [],
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.formData.seminarMovieKind == 2,
                                        expression:
                                          "formData.seminarMovieKind == 2",
                                      },
                                    ],
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          height: "auto",
                                          "white-space": "break-spaces",
                                          "font-size": "14px",
                                        },
                                        attrs: { type: "warning" },
                                      },
                                      [
                                        _vm._v(
                                          "例：https://www.youtube.com/watch?v=i4ZTyJ3dcW8"
                                        ),
                                      ]
                                    ),
                                    _c("el-input", {
                                      attrs: { placeholder: "請輸入影片連結" },
                                      model: {
                                        value: _vm.formData.seminarMovieLink,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "seminarMovieLink",
                                            $$v
                                          )
                                        },
                                        expression: "formData.seminarMovieLink",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("el-row", [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini", type: "info" },
                                          on: {
                                            click: _vm.doGetSeminarMovieEvent,
                                          },
                                        },
                                        [_vm._v("查看紀錄")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "社群連結",
                              "label-width": "100px",
                              prop: "bulletinBoard",
                            },
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 13, lg: 18 } },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "web-link",
                                            attrs: {
                                              placeholder: "請輸入官網連結",
                                            },
                                            model: {
                                              value: _vm.formData.official,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "official",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.official",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "soical_Icon",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            !!_vm.formData.official
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-view el-input__icon",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: { slot: "suffix" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleView(
                                                        _vm.formData.official
                                                      )
                                                    },
                                                  },
                                                  slot: "suffix",
                                                })
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10, lg: 5, offset: 1 } },
                                      [
                                        _c("el-switch", {
                                          staticStyle: { display: "block" },
                                          attrs: {
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            size: "mini",
                                            "active-text": "開啟",
                                            "inactive-text": "關閉",
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.linkChkDefault(
                                                "official"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.formData.officialEnable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "officialEnable",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.officialEnable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 13, lg: 18 } },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "web-link",
                                            attrs: {
                                              placeholder:
                                                "請輸入Line官方帳號連結",
                                            },
                                            model: {
                                              value: _vm.formData.line,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "line",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.line",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "ic_line",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            !!_vm.formData.line
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-view el-input__icon",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: { slot: "suffix" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleView(
                                                        _vm.formData.line
                                                      )
                                                    },
                                                  },
                                                  slot: "suffix",
                                                })
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10, lg: 5, offset: 1 } },
                                      [
                                        _c("el-switch", {
                                          staticStyle: { display: "block" },
                                          attrs: {
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            "active-text": "開啟",
                                            "inactive-text": "關閉",
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.linkChkDefault("line")
                                            },
                                          },
                                          model: {
                                            value: _vm.formData.lineEnable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "lineEnable",
                                                $$v
                                              )
                                            },
                                            expression: "formData.lineEnable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 13, lg: 18 } },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "web-link",
                                            attrs: {
                                              placeholder:
                                                "請輸入FB粉絲團連結。",
                                            },
                                            model: {
                                              value: _vm.formData.fb,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "fb",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.fb",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "ic_facebook",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            !!_vm.formData.fb
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-view el-input__icon",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: { slot: "suffix" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleView(
                                                        _vm.formData.fb
                                                      )
                                                    },
                                                  },
                                                  slot: "suffix",
                                                })
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10, lg: 5, offset: 1 } },
                                      [
                                        _c("el-switch", {
                                          staticStyle: { display: "block" },
                                          attrs: {
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            "active-text": "開啟",
                                            "inactive-text": "關閉",
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.linkChkDefault("fb")
                                            },
                                          },
                                          model: {
                                            value: _vm.formData.fbEnable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "fbEnable",
                                                $$v
                                              )
                                            },
                                            expression: "formData.fbEnable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 13, lg: 18 } },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "web-link",
                                            attrs: {
                                              placeholder: "請輸入IG連結",
                                            },
                                            model: {
                                              value: _vm.formData.ig,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ig",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.ig",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "ic_ig",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            !!_vm.formData.ig
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-view el-input__icon",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: { slot: "suffix" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleView(
                                                        _vm.formData.ig
                                                      )
                                                    },
                                                  },
                                                  slot: "suffix",
                                                })
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10, lg: 5, offset: 1 } },
                                      [
                                        _c("el-switch", {
                                          staticStyle: { display: "block" },
                                          attrs: {
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            "active-text": "開啟",
                                            "inactive-text": "關閉",
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.linkChkDefault("ig")
                                            },
                                          },
                                          model: {
                                            value: _vm.formData.igEnable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "igEnable",
                                                $$v
                                              )
                                            },
                                            expression: "formData.igEnable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 13, lg: 18 } },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "web-link",
                                            attrs: {
                                              placeholder: "請輸入Youtube連結",
                                            },
                                            model: {
                                              value: _vm.formData.yt,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "yt",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.yt",
                                            },
                                          },
                                          [
                                            _c(
                                              "template",
                                              { slot: "prepend" },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    "icon-class": "ic_youtube",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            !!_vm.formData.yt
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-view el-input__icon",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: { slot: "suffix" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleView(
                                                        _vm.formData.yt
                                                      )
                                                    },
                                                  },
                                                  slot: "suffix",
                                                })
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10, lg: 5, offset: 1 } },
                                      [
                                        _c("el-switch", {
                                          staticStyle: { display: "block" },
                                          attrs: {
                                            "active-color": "#13ce66",
                                            "inactive-color": "#ff4949",
                                            "active-text": "開啟",
                                            "inactive-text": "關閉",
                                            "active-value": true,
                                            "inactive-value": false,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.linkChkDefault("yt")
                                            },
                                          },
                                          model: {
                                            value: _vm.formData.ytEnable,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "ytEnable",
                                                $$v
                                              )
                                            },
                                            expression: "formData.ytEnable",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "App預覽",
                                  "label-width": "100px",
                                  prop: "bulletinBoard",
                                },
                              },
                              [
                                _vm.demoAccounts
                                  ? _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          margin: "5px",
                                          width: "100%",
                                        },
                                        attrs: {
                                          disabled: _vm.permissionCheck(
                                            _vm.formData.status
                                          ),
                                          multiple: "",
                                          filterable: "",
                                          clearable: "",
                                          placeholder: "請選擇可預覽的帳號",
                                        },
                                        model: {
                                          value: _vm.formData.demoAccounts,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "demoAccounts",
                                              $$v
                                            )
                                          },
                                          expression: "formData.demoAccounts",
                                        },
                                      },
                                      _vm._l(_vm.demoAccounts, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label:
                                              item.account + "-" + item.name,
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                                _c("el-tag", { attrs: { type: "success" } }, [
                                  _vm._v(
                                    "將後台帳號設定於此團，即可用此帳號輸入至APP姓名欄位並登入預覽。"
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.permissionCheck(_vm.formData.status)
                ? _c(
                    "el-button",
                    {
                      staticStyle: { color: "#4b4b4b" },
                      attrs: { type: "warning", disabled: _vm.formLoading },
                      on: {
                        click: function ($event) {
                          return _vm.saveData("dynamicValidateForm")
                        },
                      },
                    },
                    [_vm._v("儲 存")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    type: _vm.permissionCheck(_vm.formData.status)
                      ? "danger"
                      : "",
                  },
                  on: { click: _vm.handleDetailDialogClose },
                },
                [
                  _vm._v(
                    _vm._s(
                      "" +
                        (_vm.permissionCheck(_vm.formData.status)
                          ? "關 閉"
                          : "取 消")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            top: "2%",
            "append-to-body": "",
            title: "【" + _vm.travelName + "】領隊資料檢視",
            visible: _vm.dialogLeaderViewVisible,
            width: "70%",
          },
          on: {
            opened: _vm.leaderViewOpenedHandle,
            "update:visible": function ($event) {
              _vm.dialogLeaderViewVisible = $event
            },
          },
        },
        [
          _vm.dialogLeaderViewVisible
            ? _c("leader-data", {
                staticStyle: {
                  height: "calc(100vh - 210px)",
                  "overflow-y": "auto",
                },
                attrs: {
                  fatherDialogFormVisible: _vm.leaderViewdialog,
                  userID: parseInt(_vm.selectedLeaderUserID),
                },
              })
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLeaderViewVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "【" + _vm.travelName + "】領隊設定",
            visible: _vm.dialogLeaderFormVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLeaderFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.leaderSettingLoading,
                  expression: "leaderSettingLoading",
                },
              ],
            },
            [
              !_vm.addLeaderTrigger
                ? _c("el-row", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c(
                      "div",
                      [
                        _vm._l(_vm.leaderAssignments, function (assign, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticStyle: {
                                "margin-bottom": "8px",
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "70%" },
                                  attrs: {
                                    disabled: _vm.permissionCheck(
                                      _vm.formData.status
                                    ),
                                    filterable: "",
                                    placeholder: "請選擇",
                                  },
                                  model: {
                                    value: assign.leaderUserID,
                                    callback: function ($$v) {
                                      _vm.$set(assign, "leaderUserID", $$v)
                                    },
                                    expression: "assign.leaderUserID",
                                  },
                                },
                                _vm._l(_vm.leaderList, function (item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: { label: item.val, value: item.key },
                                  })
                                }),
                                1
                              ),
                              assign.leaderUserID
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onViewLeader(
                                            assign.leaderUserID
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("查看領隊資料")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        type: "info",
                                        disabled: _vm.permissionCheck(
                                          _vm.formData.status
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAddLeader(idx)
                                        },
                                      },
                                    },
                                    [_vm._v("新增領隊")]
                                  ),
                              assign.leaderUserID
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onLeaderLoginDetails(
                                            assign.leaderUserID
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("查看登入明細")]
                                  )
                                : _vm._e(),
                              !_vm.permissionCheck(_vm.formData.status)
                                ? _c("el-button", {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: {
                                      type: "danger",
                                      icon: "el-icon-close",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeLeaderRow(idx)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        _vm.leaderAssignments.length == 0
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "0px" },
                                attrs: { type: "info" },
                                on: { click: _vm.addLeaderRow },
                              },
                              [_vm._v("選擇或新增領隊")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm.addLeaderTrigger
                ? _c(
                    "el-row",
                    [
                      _c("el-alert", {
                        staticStyle: {
                          "background-color": "#ffd643",
                          color: "#4b4b4b",
                        },
                        attrs: {
                          title:
                            "新增領隊系統將以西元生日為預設密碼，ex:19880101",
                          type: "success",
                          effect: "dark",
                          closable: false,
                        },
                      }),
                      _c(
                        "el-form",
                        {
                          ref: "addLeaderForm",
                          staticStyle: { "margin-top": "10px" },
                          attrs: { model: _vm.leaderSimpleForm },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "領隊姓名",
                                "label-width": _vm.formLabelWidth,
                                prop: "name",
                                rules: [
                                  {
                                    required: true,
                                    message: "請輸入領隊姓名",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.leaderSimpleForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.leaderSimpleForm, "name", $$v)
                                  },
                                  expression: "leaderSimpleForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "領隊生日",
                                "label-width": _vm.formLabelWidth,
                                prop: "birthday",
                                rules: [
                                  {
                                    required: true,
                                    message: "請輸入領隊生日",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "請選擇領隊生日",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.leaderSimpleForm.birthday,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.leaderSimpleForm,
                                      "birthday",
                                      $$v
                                    )
                                  },
                                  expression: "leaderSimpleForm.birthday",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "領隊電話",
                                "label-width": _vm.formLabelWidth,
                                prop: "mobile",
                                rules: [
                                  {
                                    required: true,
                                    message: "請輸入領隊電話",
                                    trigger: "blur",
                                  },
                                  {
                                    required: true,
                                    pattern: _vm.pattern.mobile,
                                    message: "電話格式不正確",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { autocomplete: "off" },
                                model: {
                                  value: _vm.leaderSimpleForm.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.leaderSimpleForm,
                                      "mobile",
                                      $$v
                                    )
                                  },
                                  expression: "leaderSimpleForm.mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.addLeaderTrigger
                ? [
                    !_vm.permissionCheck(_vm.formData.status)
                      ? _c("el-button", {
                          staticStyle: {
                            background: "#ffd643",
                            "border-color": "#ffd643",
                            color: "#4b4b4b",
                            "margin-right": "10px",
                          },
                          attrs: {
                            type: "warning",
                            icon: "el-icon-plus",
                            circle: "",
                            title: "新增領隊欄位",
                          },
                          on: { click: _vm.addLeaderRow },
                        })
                      : _vm._e(),
                    !_vm.permissionCheck(_vm.formData.status)
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "#4b4b4b" },
                            attrs: { type: "warning" },
                            on: { click: _vm.setTourLeaders },
                          },
                          [_vm._v("儲存")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: !_vm.permissionCheck(_vm.formData.status)
                            ? ""
                            : "danger",
                        },
                        on: {
                          click: function ($event) {
                            _vm.dialogLeaderFormVisible = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            !_vm.permissionCheck(_vm.formData.status)
                              ? "取消"
                              : "關閉"
                          )
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4b4b4b" },
                        attrs: { type: "warning" },
                        on: { click: _vm.AddLeaderInfo },
                      },
                      [_vm._v("儲 存")]
                    ),
                    _c("el-button", { on: { click: _vm.cancelAddLeader } }, [
                      _vm._v("取 消"),
                    ]),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.travelerLoading,
              expression: "travelerLoading",
            },
          ],
          attrs: {
            title: "【" + _vm.travelName + "】旅客設定",
            visible: _vm.dialogTravelersFormVisible,
            width: "80%",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTravelersFormVisible = $event
            },
            closed: _vm.travelersFormOnClose,
          },
        },
        [
          _vm.dialogTravelersFormVisible
            ? _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.travelersTableLoading,
                      expression: "travelersTableLoading",
                    },
                  ],
                  staticClass: "full-height",
                  staticStyle: { height: "600px", "min-height": "500px" },
                },
                [
                  _vm.exlImportErrorMsg
                    ? _c(
                        "el-alert",
                        {
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: { type: "error", effect: "dark" },
                        },
                        [_vm._v(_vm._s(_vm.exlImportErrorMsg))]
                      )
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      staticClass: "filter-form",
                      attrs: { inline: true },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.getTravelers($event)
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "旅客查詢" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "輸入旅客名字/電話" },
                            model: {
                              value: _vm.travelerQuery.qry,
                              callback: function ($$v) {
                                _vm.$set(_vm.travelerQuery, "qry", $$v)
                              },
                              expression: "travelerQuery.qry",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-button", {
                        staticStyle: {
                          "margin-top": "8px",
                          "margin-left": "5px",
                        },
                        attrs: {
                          type: "primary",
                          icon: "el-icon-search",
                          circle: "",
                          disabled: _vm.listLoading,
                        },
                        on: { click: _vm.getTravelers },
                      }),
                      !_vm.permissionCheck(_vm.formData.status)
                        ? _c("el-button", {
                            attrs: {
                              type: "warning",
                              circle: "",
                              icon: "el-icon-plus",
                              disabled: _vm.listLoading,
                            },
                            on: { click: _vm.addTravelers },
                          })
                        : _vm._e(),
                      !_vm.permissionCheck(_vm.formData.status)
                        ? _c("el-button", {
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              loading: _vm.listLoading,
                              type: _vm.isEditMode ? "danger" : "success",
                              circle: "",
                              icon: _vm.isEditMode
                                ? "el-icon-close"
                                : "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                _vm.isEditMode = !_vm.isEditMode
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    { attrs: { inline: true } },
                    [
                      !_vm.permissionCheck(_vm.formData.status)
                        ? _c("el-form-item", { attrs: { label: "檔案" } }, [
                            _c(
                              "div",
                              [
                                _c("Upload", {
                                  ref: "excelImportRef",
                                  attrs: {
                                    accept: ".xls,.xlsx,.csv,.PDF,.doc,.docx",
                                    payload: _vm.formData,
                                    "data-obj": {
                                      id: 0,
                                      type: "travelersImport",
                                      user: "",
                                    },
                                    "limit-file-count": 1,
                                    "use-drag": false,
                                    action: "TravelSettings/importTravelers",
                                    "auto-upload": false,
                                    "show-file-list": true,
                                    "form-on-loading-parent": _vm.formLoading,
                                    "btn-txt": "選擇檔案",
                                    "show-limit": false,
                                    "btn-style": "primary",
                                    "before-file-list": [],
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      !_vm.permissionCheck(_vm.formData.status)
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "mini" },
                                  on: { click: _vm.doImportExcel },
                                },
                                [_vm._v(" 匯入 ")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success", size: "mini" },
                                  on: { click: _vm.openUrl },
                                },
                                [_vm._v(" 下載範例 ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.getLeaderNamesDisplay(_vm.formData)
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "info" },
                                  on: { click: _vm.viewTourLeader },
                                },
                                [_vm._v("查看領隊資料")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        [
                          _vm.pdfFiles && _vm.pdfFiles.length > 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "info",
                                    plain: "",
                                    size: "mini",
                                  },
                                  on: { click: _vm.handleDownloadPdf },
                                },
                                [_vm._v(" 查看總表檔案 ")]
                              )
                            : _vm._e(),
                          _vm.pdfFiles &&
                          _vm.pdfFiles.length > 0 &&
                          !_vm.permissionCheck(_vm.formData.status)
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    plain: "",
                                    size: "mini",
                                  },
                                  on: { click: _vm.handleDeletePdf },
                                },
                                [_vm._v(" 刪除總表檔案 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.permissionCheck(_vm.formData.status)
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 24 } },
                                    [
                                      _c("Upload", {
                                        ref: "uploadPdfRef",
                                        attrs: {
                                          accept: ".pdf",
                                          payload: _vm.uploadPdf,
                                          "data-obj": {
                                            id: 0,
                                            type: "travelersUploadPdf",
                                            user: "",
                                          },
                                          "limit-file-count": 1,
                                          "use-drag": false,
                                          action:
                                            "TravelSettings/uploadTravelers",
                                          "auto-upload": false,
                                          "show-file-list": true,
                                          "show-limit": false,
                                          "form-on-loading-parent":
                                            _vm.formLoading,
                                          "btn-txt": "上傳總表",
                                          "btn-style": "text",
                                          "before-file-list": [],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.permissionCheck(_vm.formData.status)
                    ? _c(
                        "el-alert",
                        {
                          staticStyle: {
                            "background-color": "#ffd643",
                            color: "#4b4b4b",
                            "margin-bottom": "10px",
                          },
                          attrs: {
                            type: "success",
                            effect: "dark",
                            closable: false,
                          },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(" 1、帳號相同姓名不相同系統視為多筆帳號"),
                            _c("br"),
                            _vm._v(
                              " 2、只有持有旅客角色權限才會出現於列表(匯入直接設定角色，調整角色只限ITA管理員)"
                            ),
                            _c("br"),
                            _vm._v(
                              " 3、手動加入之旅客基本資料填寫完畢後請先點擊【加入】才能正確加入旅客"
                            ),
                            _c("br"),
                            _vm._v(" 4，領隊預設使用"),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("【西元生日】"),
                            ]),
                            _vm._v(
                              "當作登入密碼，ex:西元1988-01-01 預設密碼為：19880101，生日可接受格式：【1911-01-01】、【1911/01/01】 "
                            ),
                          ]),
                        ],
                        2
                      )
                    : _c(
                        "el-alert",
                        {
                          staticStyle: {
                            "background-color": "#ffd643",
                            color: "#4b4b4b",
                            "margin-bottom": "10px",
                          },
                          attrs: { type: "warning", closable: false },
                        },
                        [
                          _c("template", { slot: "title" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  "旅遊團狀態為：【" +
                                    _vm.formData.statusDesc +
                                    "】已無法【新增 / 編輯 / 刪除】旅客資料"
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        2
                      ),
                  _c(
                    "div",
                    { staticClass: "full-height travelers-div" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticClass: "travelers-table",
                          staticStyle: { width: "100%", position: "relative" },
                          attrs: {
                            height: "300",
                            border: "",
                            size: "mini",
                            data: _vm.travelersList,
                            "tooltip-effect": "dark",
                          },
                          on: { "selection-change": _vm.handleSelectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "項次",
                              width: "60",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.$index + 1)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4178052834
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "travelersGroup",
                              label: "分組",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: { disabled: !_vm.isEditMode },
                                        model: {
                                          value: scope.row.travelersGroup,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "travelersGroup",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.travelersGroup",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2022481204
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "travelersIdentity",
                              label: "身份",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: { disabled: !_vm.isEditMode },
                                        model: {
                                          value: scope.row.travelersIdentity,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "travelersIdentity",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.travelersIdentity",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              456560989
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "姓名",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            !_vm.isEditMode ||
                                            !!scope.row.userID,
                                        },
                                        model: {
                                          value: scope.row.name,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "name", $$v)
                                          },
                                          expression: "scope.row.name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              599914764
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "birthDay",
                              label: "生日",
                              align: "center",
                              width: "190",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            !_vm.isEditMode ||
                                            !!scope.row.userID,
                                          maxlength: 10,
                                        },
                                        model: {
                                          value: scope.row.birthDay,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "birthDay",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "scope.row.birthDay",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2574888477
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "mobile",
                              label: "電話(非必填)",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            !_vm.isEditMode ||
                                            (!!scope.row.userID &&
                                              _vm.checkHasMobile(
                                                scope.row.userID
                                              )),
                                        },
                                        model: {
                                          value: scope.row.mobile,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "mobile", $$v)
                                          },
                                          expression: "scope.row.mobile",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1841543467
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "isMain",
                              label: "主要旅客(可登入APP)",
                              align: "center",
                              width: "140",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          disabled: !_vm.isEditMode,
                                          "active-text": "是",
                                          "inactive-text": "否",
                                          "active-color": "#13ce66",
                                          "inactive-color": "#ff4949",
                                          "active-value": true,
                                          "inactive-value": false,
                                        },
                                        model: {
                                          value: scope.row.isMain,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "isMain", $$v)
                                          },
                                          expression: "scope.row.isMain",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              139892483
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "mail",
                              label: "EMail (非必填)",
                              align: "center",
                              width: "200",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: { disabled: !_vm.isEditMode },
                                        model: {
                                          value: scope.row.mail,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "mail", $$v)
                                          },
                                          expression: "scope.row.mail",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              364602110
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "agencyRemind",
                              label: "旅行社提醒 (非必填)",
                              "show-overflow-tooltip": "",
                              width: "250",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: !_vm.isEditMode,
                                          type: "textarea",
                                        },
                                        model: {
                                          value: scope.row.notice.agencyRemind,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.notice,
                                              "agencyRemind",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.notice.agencyRemind",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              840644201
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "leaderRemind",
                              label: "領隊備註 (非必填)",
                              "show-overflow-tooltip": "",
                              width: "250",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-input", {
                                        attrs: {
                                          disabled: !_vm.isEditMode,
                                          type: "textarea",
                                        },
                                        model: {
                                          value: scope.row.notice.leaderRemind,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.notice,
                                              "leaderRemind",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.notice.leaderRemind",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              297000645
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "登入/登出次數",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return scope.row.loginTimes &&
                                      scope.row.loginTimes.length > 0
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "success",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.partingLoginTime(
                                                    scope.row.loginTimes,
                                                    1
                                                  ).length
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v("/"),
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.partingLoginTime(
                                                    scope.row.loginTimes,
                                                    2
                                                  ).length
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : undefined
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "明細" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.loginTimes &&
                                      scope.row.loginTimes.length > 0
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "info",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getLoginDetails(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("明細")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3002271544
                            ),
                          }),
                          !_vm.permissionCheck(_vm.formData.status)
                            ? _c("el-table-column", {
                                attrs: { label: "刪除", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.isJoin
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type:
                                                      _vm.partingLoginTime(
                                                        scope.row.loginTimes ||
                                                          [],
                                                        1
                                                      ).length > 0
                                                        ? "info"
                                                        : "danger",
                                                    disabled:
                                                      _vm.partingLoginTime(
                                                        scope.row.loginTimes ||
                                                          [],
                                                        1
                                                      ).length > 0,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteTravelers(
                                                        scope.row.userID,
                                                        scope.row.name,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.partingLoginTime(
                                                          scope.row
                                                            .loginTimes || [],
                                                          1
                                                        ).length > 0
                                                          ? "已使用"
                                                          : "刪除"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2769174306
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.permissionCheck(_vm.formData.status)
                ? _c(
                    "el-button",
                    {
                      staticStyle: { color: "#4b4b4b" },
                      attrs: {
                        type: "warning",
                        disabled: _vm.travelersTableLoading,
                      },
                      on: { click: _vm.setTravelers },
                    },
                    [_vm._v("儲 存")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    type: !_vm.permissionCheck(_vm.formData.status)
                      ? ""
                      : "danger",
                  },
                  on: {
                    click: function ($event) {
                      _vm.dialogTravelersFormVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      !_vm.permissionCheck(_vm.formData.status)
                        ? "取 消"
                        : "關 閉"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            title: "【" + _vm.travelName + "】行程設定",
            visible: _vm.dialogPlanningFormVisible,
            fullscreen: "",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPlanningFormVisible = $event
            },
            closed: _vm.onPlanningDialogClosed,
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.planningSettingLoading,
                  expression: "planningSettingLoading",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    display: "flex",
                    "align-items": "flex-end",
                    gap: "0 10px",
                  },
                },
                [
                  _vm.planningData && _vm.planningData.thisTime.data.length == 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "success" },
                          on: { click: _vm.refreshItinerary },
                        },
                        [_vm._v("重新整理")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.permissionCheck(_vm.formData.status),
                          expression: "!permissionCheck(formData.status)",
                        },
                      ],
                      attrs: { size: "mini", type: "primary", plain: "" },
                      on: { click: _vm.editTravelInfoAnalyticsFormByPlanning },
                    },
                    [_vm._v("AI資料匯入")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "0" },
                      attrs: { size: "mini", type: "danger" },
                      on: { click: _vm.handleNoticeDialog },
                    },
                    [_vm._v("注意事項")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { position: "relative", flex: "2" } },
                    [
                      _c("Upload", {
                        ref: "uploadHandbookRef",
                        staticClass: "manual",
                        attrs: {
                          accept: ".pdf",
                          payload: _vm.planningData,
                          "data-obj": _vm.fileObj,
                          "limit-file-count": 1,
                          "use-drag": false,
                          limitText: "檔案須為.pdf格式，限制不超過2000MB",
                          "show-limit": false,
                          action: "TravelSettings/tourHandbook",
                          "auto-upload": false,
                          "show-file-list": true,
                          "form-on-loading-parent": _vm.formLoading,
                          "btn-txt": "上傳手冊",
                          "before-file-list":
                            _vm.formData.handbook &&
                            _vm.formData.handbook.length
                              ? _vm.formData.handbook[0].files
                              : [],
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.planningTab,
                    callback: function ($$v) {
                      _vm.planningTab = $$v
                    },
                    expression: "planningTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "行程規劃", name: "thisDays" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "max-height": "calc(100vh - 350px)",
                            overflow: "auto",
                          },
                        },
                        _vm._l(
                          _vm.planningData.thisTime.data,
                          function (item, index) {
                            return _c(
                              "el-form",
                              {
                                key: index,
                                staticClass: "demo-form-inline",
                                attrs: { inline: true },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c("el-tag", [
                                      _vm._v("Day" + _vm._s(index + 1)),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.checkPermission(["ITA-DEV"]),
                                        expression:
                                          "checkPermission(['ITA-DEV'])",
                                      },
                                    ],
                                    attrs: { label: "區域" },
                                  },
                                  [
                                    item.regions
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              "value-key": "key",
                                              placeholder: "區域",
                                              size: "mini",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectedRegion(item)
                                              },
                                            },
                                            model: {
                                              value: item.region,
                                              callback: function ($$v) {
                                                _vm.$set(item, "region", $$v)
                                              },
                                              expression: "item.region",
                                            },
                                          },
                                          _vm._l(
                                            item.regions,
                                            function (c, ind) {
                                              return _c("el-option", {
                                                key: ind,
                                                attrs: {
                                                  label: c.val,
                                                  value: c.key,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.checkPermission(["ITA-DEV"]),
                                        expression:
                                          "checkPermission(['ITA-DEV'])",
                                      },
                                    ],
                                    attrs: { label: "國家" },
                                  },
                                  [
                                    item.countries
                                      ? _c(
                                          "el-select",
                                          {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName: "v-loading",
                                                value: item.countriesLoading,
                                                expression:
                                                  "item.countriesLoading",
                                              },
                                            ],
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              filterable: "",
                                              placeholder: "國家",
                                              "value-key": "code",
                                              size: "mini",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectedCountry(item)
                                              },
                                            },
                                            model: {
                                              value: item.country,
                                              callback: function ($$v) {
                                                _vm.$set(item, "country", $$v)
                                              },
                                              expression: "item.country",
                                            },
                                          },
                                          _vm._l(
                                            item.countries,
                                            function (c, ind) {
                                              return _c("el-option", {
                                                key: ind,
                                                attrs: {
                                                  label: c.chtName,
                                                  value: c,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.checkPermission(["ITA-DEV"]),
                                        expression:
                                          "checkPermission(['ITA-DEV'])",
                                      },
                                    ],
                                    attrs: { label: "城市" },
                                  },
                                  [
                                    item.cities
                                      ? _c(
                                          "el-select",
                                          {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName: "v-loading",
                                                value:
                                                  item.countriesLoading ||
                                                  item.citiesLoading,
                                                expression:
                                                  "item.countriesLoading || item.citiesLoading",
                                              },
                                            ],
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              clearable: "",
                                              filterable: "",
                                              placeholder: "城市",
                                              "value-key": "code",
                                              size: "mini",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.selectedCity(item)
                                              },
                                            },
                                            model: {
                                              value: item.city,
                                              callback: function ($$v) {
                                                _vm.$set(item, "city", $$v)
                                              },
                                              expression: "item.city",
                                            },
                                          },
                                          _vm._l(
                                            item.cities,
                                            function (c, ind) {
                                              return _c("el-option", {
                                                key: ind,
                                                attrs: {
                                                  label: c.chtName,
                                                  value: c,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.checkPermission(["ITA-DEV"]),
                                        expression:
                                          "checkPermission(['ITA-DEV'])",
                                      },
                                    ],
                                    attrs: { label: "經緯度(lng,lat)" },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "line",
                                        attrs: { span: 12 },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "經度(lng)" },
                                          model: {
                                            value: item.lng,
                                            callback: function ($$v) {
                                              _vm.$set(item, "lng", $$v)
                                            },
                                            expression: "item.lng",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "line",
                                        attrs: { span: 12 },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "緯度(lat)" },
                                          model: {
                                            value: item.lat,
                                            callback: function ($$v) {
                                              _vm.$set(item, "lat", $$v)
                                            },
                                            expression: "item.lat",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "widh-input",
                                    staticStyle: { width: "90%" },
                                    attrs: { label: "行程說明" },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "line",
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "textarea",
                                            rows: 6,
                                            resize: "none",
                                            placeholder: "行程說明",
                                          },
                                          model: {
                                            value: item.description,
                                            callback: function ($$v) {
                                              _vm.$set(item, "description", $$v)
                                            },
                                            expression: "item.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "widh-input",
                                    staticStyle: {
                                      width: "90%",
                                      "padding-left": "4.3em",
                                    },
                                    attrs: { label: "當日餐食" },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "line",
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "106.3%" },
                                          attrs: {
                                            placeholder:
                                              "ex: 早餐： 飯店 /中午：日式定食 /晚餐：燒肉套餐",
                                          },
                                          model: {
                                            value: item.food,
                                            callback: function ($$v) {
                                              _vm.$set(item, "food", $$v)
                                            },
                                            expression: "item.food",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "widh-input",
                                    staticStyle: {
                                      width: "90%",
                                      "padding-left": "4.3em",
                                    },
                                    attrs: { label: "住宿旅館" },
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "line",
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "106.3%" },
                                          attrs: { placeholder: "住宿旅館" },
                                          model: {
                                            value: item.hotelName,
                                            callback: function ($$v) {
                                              _vm.$set(item, "hotelName", $$v)
                                            },
                                            expression: "item.hotelName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "success",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEditPlanDialog(
                                              index + 1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.permissionCheck(
                                                _vm.formData.status
                                              )
                                                ? "查看"
                                                : "編輯"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "info", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getTravelPositionRecord(
                                              index + 1,
                                              item.description
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("足跡")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.isProdMode,
                                            expression: "!isProdMode",
                                          },
                                        ],
                                        attrs: { type: "info", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.getTravelPositionRecordForTest(
                                              index + 1,
                                              item.description
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("足跡(測試資料)")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ]
                  ),
                  false
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "精彩行程", name: "thisTimes" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "form",
                                  attrs: {
                                    "label-width": "130px",
                                    "label-position": "right",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "上午景點" } },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.planningData.theDay
                                                      .morningSights,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planningData.theDay,
                                                      "morningSights",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planningData.theDay.morningSights",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "早餐" } },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.planningData.theDay
                                                      .breakfast,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planningData.theDay,
                                                      "breakfast",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planningData.theDay.breakfast",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "下午景點" } },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.planningData.theDay
                                                      .afternoonAttractions,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planningData.theDay,
                                                      "afternoonAttractions",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planningData.theDay.afternoonAttractions",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "午餐" } },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.planningData.theDay
                                                      .lunch,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planningData.theDay,
                                                      "lunch",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planningData.theDay.lunch",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "晚間景點" } },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.planningData.theDay
                                                      .eveningAttractions,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planningData.theDay,
                                                      "eveningAttractions",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planningData.theDay.eveningAttractions",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "晚餐" } },
                                            [
                                              _c("el-input", {
                                                model: {
                                                  value:
                                                    _vm.planningData.theDay
                                                      .dinner,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.planningData.theDay,
                                                      "dinner",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "planningData.theDay.dinner",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "本日行程注意事項" } },
                                    [
                                      _c("el-input", {
                                        model: {
                                          value:
                                            _vm.planningData.theDay
                                              .notesOnToday,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.planningData.theDay,
                                              "notesOnToday",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "planningData.theDay.notesOnToday",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.permissionCheck(_vm.formData.status),
                      expression: "!permissionCheck(formData.status)",
                    },
                  ],
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.planningSettingSave },
                },
                [_vm._v("儲 存")]
              ),
              _c("el-button", { on: { click: _vm.planningSettingCancel } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "【" + _vm.travelName + "】注意事項",
            visible: _vm.noticeSettingVisible,
            width: "90%",
            "close-on-click-modal": false,
            "before-close": _vm.handleClearNotice,
          },
          on: {
            "update:visible": function ($event) {
              _vm.noticeSettingVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            staticStyle: { color: "#4b4b4b", "margin-bottom": "10px" },
            attrs: {
              title:
                "為了給旅客APP更好的呈現效果，建議字型大小設定為36pt以上。",
              type: "warning",
              effect: "dark",
              closable: false,
            },
          }),
          _vm.noticeSettingVisible
            ? _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.noticeSettingLoading,
                      expression: "noticeSettingLoading",
                    },
                  ],
                },
                [
                  _c("tinymce", {
                    ref: "tinymceNotice_" + _vm.selectedTravelID,
                    attrs: {
                      id: "tinymceNotice_" + _vm.selectedTravelID,
                      height: 300,
                      type: 27,
                    },
                    model: {
                      value: _vm.noticeContent,
                      callback: function ($$v) {
                        _vm.noticeContent = $$v
                      },
                      expression: "noticeContent",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "template",
            { staticClass: "dialog-footer", slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.permissionCheck(_vm.formData.status),
                      expression: "!permissionCheck(formData.status)",
                    },
                  ],
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning", loading: _vm.noticeSettingLoading },
                  on: { click: _vm.handleSetNotice },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: !_vm.permissionCheck(_vm.formData.status)
                      ? ""
                      : "danger",
                  },
                  on: { click: _vm.handleCancelNotice },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        !_vm.permissionCheck(_vm.formData.status)
                          ? "取消"
                          : "關閉"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "【" + _vm.travelName + "】編輯行程內容 Day" + _vm.planDay,
            visible: _vm.planSettingVisible,
            width: "90%",
            "close-on-click-modal": false,
            "before-close": _vm.handleClearPlan,
          },
          on: {
            "update:visible": function ($event) {
              _vm.planSettingVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            staticStyle: { color: "#4b4b4b", "margin-bottom": "10px" },
            attrs: {
              title:
                "為了給旅客APP更好的呈現效果，建議字型大小設定為36pt以上。",
              type: "warning",
              effect: "dark",
              closable: false,
            },
          }),
          _vm.planSettingVisible
            ? _c(
                "el-card",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.planSettingLoading,
                      expression: "planSettingLoading",
                    },
                  ],
                },
                [
                  _c("tinymce", {
                    ref:
                      "tinymcePlan_" + _vm.planDay + "_" + _vm.selectedTravelID,
                    attrs: {
                      id:
                        "tinymcePlan_" +
                        _vm.planDay +
                        "_" +
                        _vm.selectedTravelID,
                      height: 300,
                      type: 27,
                    },
                    model: {
                      value: _vm.planContent,
                      callback: function ($$v) {
                        _vm.planContent = $$v
                      },
                      expression: "planContent",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "template",
            { staticClass: "dialog-footer", slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.permissionCheck(_vm.formData.status),
                      expression: "!permissionCheck(formData.status)",
                    },
                  ],
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning", loading: _vm.planSettingLoading },
                  on: { click: _vm.handleSetPlan },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: !_vm.permissionCheck(_vm.formData.status)
                      ? ""
                      : "danger",
                  },
                  on: {
                    click: function ($event) {
                      _vm.planSettingVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        !_vm.permissionCheck(_vm.formData.status)
                          ? "取消"
                          : "關閉"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.duplicateMultipleTravelLoading,
              expression: "duplicateMultipleTravelLoading",
            },
          ],
          attrs: {
            title:
              "【" + _vm.duplicateTravelFormData.travelName + "】複製多團設定",
            visible: _vm.dialogDuplicateMultipleTravelVisible,
            width: "80%",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDuplicateMultipleTravelVisible = $event
            },
            closed: _vm.dialogDuplicateMultipleTravelOnClose,
          },
        },
        [
          _c(
            "el-alert",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "error", closable: false },
            },
            [
              _c(
                "p",
                {
                  staticStyle: { "line-height": "1.8rem", "font-size": "15px" },
                },
                [
                  _vm._v(
                    " 複製新的旅遊團耗時較久請耐心等待，視原始團檔案大小而定。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 複製項目：1、旅遊團基本資料 2、每日行程資料 3、攜帶物品資料"
                  ),
                  _c("br"),
                  _vm._v(
                    " 複製完畢後，請另行設定：1、領隊及旅客匯入、分組、安排座位 2、上傳旅遊手冊、上傳說明會影片 "
                  ),
                ]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              ref: "multipleCopyTable",
              staticStyle: { width: "100%", position: "relative" },
              attrs: {
                height: "300",
                border: "",
                size: "mini",
                data: _vm.duplicateTableFormData.tableData,
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "tourGroupNo",
                  label: "團號",
                  align: "center",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { clearable: "" },
                          model: {
                            value: scope.row.tourGroupNo,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "tourGroupNo", $$v)
                            },
                            expression: "scope.row.tourGroupNo",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "beginDate",
                  label: "行程日期區間",
                  align: "center",
                  width: "380",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "range-separator": "至",
                            "start-placeholder": "開始日期",
                            "end-placeholder": "結束日期",
                            "value-format": "yyyy-MM-dd",
                            "picker-options": _vm.pickerBeginDateLimitOptions,
                          },
                          model: {
                            value: scope.row.dateRange,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "dateRange", $$v)
                            },
                            expression: "scope.row.dateRange",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "beginTime",
                  label: "集合出發時間",
                  align: "center",
                  width: "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-time-select", {
                          staticStyle: { width: "100%", "font-size": "12px" },
                          attrs: {
                            clearable: false,
                            "picker-options": {
                              start: "00:00",
                              step: "00:15",
                              end: "23:45",
                            },
                            placeholder: "選擇時間",
                          },
                          on: { change: function ($event) {} },
                          model: {
                            value: scope.row.beginTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "beginTime", $$v)
                            },
                            expression: "scope.row.beginTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "endTime",
                  label: "行程結束時間",
                  align: "center",
                  width: "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-time-select", {
                          staticStyle: { width: "100%", "font-size": "12px" },
                          attrs: {
                            clearable: false,
                            "picker-options": {
                              start: "00:00",
                              step: "00:15",
                              end: "23:45",
                            },
                            placeholder: "選擇時間",
                          },
                          model: {
                            value: scope.row.endTime,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "endTime", $$v)
                            },
                            expression: "scope.row.endTime",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                size: "small",
                                plain: "",
                                circle: "",
                                icon: "el-icon-delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteNewCopyRow(scope.row)
                                },
                              },
                            }),
                            _c("el-button", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    scope.$index + 1 ===
                                    _vm.duplicateTableFormData.tableData.length,
                                  expression:
                                    "scope.$index + 1 === duplicateTableFormData.tableData.length",
                                },
                              ],
                              attrs: {
                                size: "small",
                                plain: "",
                                type: "primary",
                                circle: "",
                                icon: "el-icon-plus",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleAddNewCopyRow(scope.row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "5px", color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.saveDuplicateMultipleTravel },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDuplicateMultipleTravelVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "複製多團設定結果",
            visible: _vm.dialogDuplicateMultipleTravelResultVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDuplicateMultipleTravelResultVisible = $event
            },
            closed: _vm.dialogDuplicateMultipleTravelResultOnClose,
          },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c("div", [
              _c(
                "div",
                { staticStyle: { position: "relative", height: "400px" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.showDownloadLoading,
                          expression: "showDownloadLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.duplicateMultipleTravelResult,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "100%",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "成功團號" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.type == "success"
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "success",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s("" + scope.row.group) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "失敗團號" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.type == "fail"
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "danger",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s("" + scope.row.group) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDuplicateMultipleTravelResultVisible = false
                    },
                  },
                },
                [_vm._v("確 認")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "報名介紹",
            visible: _vm.signUpTravelDialogVisible,
            width: "40%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.signUpTravelDialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            staticStyle: { width: "100%" },
            attrs: {
              type: "textarea",
              rows: 8,
              placeholder: "請輸入報名介紹內容",
            },
            model: {
              value: _vm.signUpNotice,
              callback: function ($$v) {
                _vm.signUpNotice = $$v
              },
              expression: "signUpNotice",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.signUpTravel } },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.signUpTravelDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogCheckInPointLoading,
              expression: "dialogCheckInPointLoading",
            },
          ],
          attrs: {
            width: "60%",
            "append-to-body": "",
            visible: _vm.dialogCheckInPointVisible,
            title: "【" + _vm.travelName + "】報到點設定",
            top: "2%",
          },
          on: {
            open: _vm.loadCheckInPoints,
            "update:visible": function ($event) {
              _vm.dialogCheckInPointVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                color: "red",
                "margin-bottom": "10px",
                "font-size": "14px",
              },
            },
            [
              _vm._v(
                " 請自行開啟GOOGLE MAP，在該景點按滑鼠右鍵，點擊第一個經緯度座標複製，然後依序貼到此處報到點座標。 "
              ),
            ]
          ),
          _vm._l(_vm.checkInPointList, function (point, index) {
            return _c(
              "div",
              { key: index, staticStyle: { "margin-bottom": "15px" } },
              [
                _c(
                  "el-card",
                  { staticClass: "box-card" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix",
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", [_vm._v("報到點 " + _vm._s(index + 1))]),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "auto" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeCheckInPoint(index)
                                  },
                                },
                              },
                              [_vm._v("刪除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-form",
                      {
                        ref: "checkInForm" + index,
                        refInFor: true,
                        attrs: {
                          model: point,
                          "label-width": _vm.formLabelWidth,
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "報到點使用區域",
                              prop: "countryAreaList",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入景點區域",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-cascader", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                props: {
                                  checkStrictly: true,
                                  expandTrigger: "hover",
                                },
                                placeholder: "請選擇",
                                filterable: "",
                                options: _vm.travelAttractionsCascaderMenu,
                              },
                              model: {
                                value: point.countryAreaList,
                                callback: function ($$v) {
                                  _vm.$set(point, "countryAreaList", $$v)
                                },
                                expression: "point.countryAreaList",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "報到點名稱",
                              prop: "viewPointName",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入景點名稱",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "" },
                              model: {
                                value: point.viewPointName,
                                callback: function ($$v) {
                                  _vm.$set(point, "viewPointName", $$v)
                                },
                                expression: "point.viewPointName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "報到點座標" } },
                          [
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "北緯(lat)",
                                          prop: "lat",
                                          rules: [
                                            {
                                              required: true,
                                              message: "請輸座標北緯度",
                                              trigger: "blur",
                                            },
                                            {
                                              pattern: /^-?\d+(\.\d+)?$/,
                                              message:
                                                "座標緯度必須為數字(可含小數點)",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "24.9607911738373436",
                                          },
                                          model: {
                                            value: point.lat,
                                            callback: function ($$v) {
                                              _vm.$set(point, "lat", $$v)
                                            },
                                            expression: "point.lat",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "東經(lng)",
                                          prop: "lng",
                                          rules: [
                                            {
                                              required: true,
                                              message: "請輸座標東經度",
                                              trigger: "blur",
                                            },
                                            {
                                              pattern: /^-?\d+(\.\d+)?$/,
                                              message:
                                                "座標經度必須為數字(可含小數點)",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "121.215721005525152",
                                          },
                                          model: {
                                            value: point.lng,
                                            callback: function ($$v) {
                                              _vm.$set(point, "lng", $$v)
                                            },
                                            expression: "point.lng",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "報到完成設定" } },
                          [
                            _c("Upload", {
                              ref: "uploadCheckInRef" + index,
                              refInFor: true,
                              attrs: {
                                accept: ".jpg,.jpeg,.png",
                                payload: point,
                                "data-obj": {
                                  id: _vm.selectedTravelID,
                                  type: "checkInPoint",
                                },
                                "limit-file-count": 1,
                                limitText:
                                  "報到完成圖片須為.jpg,.jpeg,.png格式，限制不超過2MB",
                                "use-drag": false,
                                action: "TravelSettings/checkInPointImage",
                                "auto-upload": false,
                                "show-file-list": true,
                                "form-on-loading-parent":
                                  _vm.dialogCheckInPointLoading,
                                "btn-txt": "上傳報到完成圖片",
                                "before-file-list":
                                  point.fileInfo && point.fileInfo.length
                                    ? point.fileInfo[0].files
                                    : [],
                              },
                            }),
                            point.checkInFinishImgUrl &&
                            point.checkInFinishImgUrl.trim()
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "10px" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#666",
                                          "margin-bottom": "5px",
                                        },
                                      },
                                      [_vm._v("目前圖片：")]
                                    ),
                                    _c(
                                      "el-image",
                                      {
                                        staticStyle: {
                                          width: "200px",
                                          height: "150px",
                                          border: "1px solid #ddd",
                                          "border-radius": "4px",
                                        },
                                        attrs: {
                                          src: point.checkInFinishImgUrl,
                                          fit: "cover",
                                          "preview-src-list": [
                                            point.checkInFinishImgUrl,
                                          ],
                                          "z-index": 9999,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-slot",
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content": "center",
                                              "align-items": "center",
                                              width: "100%",
                                              height: "100%",
                                              background: "#f5f7fa",
                                              color: "#909399",
                                            },
                                            attrs: { slot: "error" },
                                            slot: "error",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-picture-outline",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "5px",
                                                },
                                              },
                                              [_vm._v("圖片載入失敗")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "導引頁面" } },
                          [
                            _c("el-input", {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                placeholder:
                                  "請輸入網址，未輸入時將顯示預設資訊。",
                              },
                              model: {
                                value: point.guidePage,
                                callback: function ($$v) {
                                  _vm.$set(point, "guidePage", $$v)
                                },
                                expression: "point.guidePage",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#666",
                                  "font-size": "12px",
                                },
                              },
                              [_vm._v("請輸入網址，未輸入時將顯示預設資訊。")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addNewCheckInPoint },
                },
                [_vm._v("新增報到點")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.saveCheckInPoint },
                },
                [_vm._v("儲存設定")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogCheckInPointVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogCheckInHistoryLoading,
              expression: "dialogCheckInHistoryLoading",
            },
          ],
          attrs: {
            width: "80%",
            "append-to-body": "",
            visible: _vm.dialogCheckInHistoryVisible,
            title: "【" + _vm.travelName + "】報到記錄",
            top: "2%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCheckInHistoryVisible = $event
            },
          },
        },
        [
          _vm.checkInHistoryList && _vm.checkInHistoryList.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.checkInHistoryList,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "序號", width: "60" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v(_vm._s(scope.row.index))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1054881592
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "姓名", width: "120" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [_vm._v(_vm._s(scope.row.name))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2020036417
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "兌換獎品",
                          width: "170",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.HasRedeemedPrize
                                    ? _c(
                                        "el-tag",
                                        { attrs: { type: "success" } },
                                        [
                                          _vm._v(
                                            "是 - " +
                                              _vm._s(scope.row.PrizeRedeemTime)
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "el-tag",
                                        { attrs: { type: "danger" } },
                                        [_vm._v("否")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4273835464
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "全部報到",
                          width: "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: scope.row.allCheckIn
                                          ? "success"
                                          : "danger",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.allCheckIn ? "是" : "否"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3635370745
                        ),
                      }),
                      _vm._l(_vm.checkInPointColumns, function (column, index) {
                        return _c("el-table-column", {
                          key: index,
                          attrs: {
                            label: column,
                            align: "center",
                            "min-width": "150",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row[column]
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              "是 - " +
                                                _vm._s(scope.row[column])
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("否")]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "50px 0",
                    color: "#999",
                  },
                },
                [_vm._v("暫無報到記錄")]
              ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogCheckInHistoryVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "【" + _vm.travelName + "】旅客小遊戲設定",
            visible: _vm.travelGameDialogVisible,
            fullscreen: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.travelGameDialogVisible = $event
            },
          },
        },
        [
          _c(
            "iframe",
            {
              staticStyle: { width: "100%", height: "calc(100vh - 160px)" },
              attrs: { src: _vm.travelGameDialogForm.editorUrl },
            },
            [_vm._v(" 您的瀏覽器不支援 iframe 標籤。 ")]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.travelGameDialogVisible = false
                    },
                  },
                },
                [_vm._v("關閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-form",
        { staticClass: "filter-form", attrs: { inline: true } },
        [
          _vm.checkPermission(["ITA-DEV", "ITA-ADMIN", "ITA-ADM-STAFF"])
            ? _c(
                "el-form-item",
                { attrs: { label: "旅行社" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "請選擇旅行社",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listQuery.agencyCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "agencyCode", $$v)
                        },
                        expression: "listQuery.agencyCode",
                      },
                    },
                    _vm._l(_vm.agencyList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              staticClass: "listquery-target-point",
              staticStyle: { width: "300px", height: "47px" },
              attrs: { label: "目的地" },
            },
            [
              _c(
                "div",
                { staticClass: "block", staticStyle: { width: "100%" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%", top: "0px" },
                    attrs: {
                      "popper-class": "travel-data-cascader",
                      clearable: "",
                      "collapse-tags": "",
                      props: {
                        multiple: true,
                        checkStrictly: false,
                        expandTrigger: "hover",
                      },
                      placeholder: "請選擇",
                      filterable: "",
                      options: _vm.travelAttractionsCascaderMenu,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.getPositionAndCouurncy()
                      },
                    },
                    model: {
                      value: _vm.listQuery.countryArea,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "countryArea", $$v)
                      },
                      expression: "listQuery.countryArea",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "團號" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入團號" },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "團名" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入團名" },
                model: {
                  value: _vm.listQuery.qrySecond,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qrySecond", $$v)
                  },
                  expression: "listQuery.qrySecond",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "250px" }, attrs: { label: "出發區間" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": "至",
                  "start-placeholder": "開始日期",
                  "end-placeholder": "結束日期",
                  "picker-options": _vm.pickerOptions,
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.listQuery.dateFilter,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "dateFilter", $$v)
                  },
                  expression: "listQuery.dateFilter",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "180px" }, attrs: { label: "旅遊性質" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "請選擇",
                  },
                  model: {
                    value: _vm.listQuery.travelProperty,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "travelProperty", $$v)
                    },
                    expression: "listQuery.travelProperty",
                  },
                },
                _vm._l(_vm.travelPropertyOption, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { width: "180px" }, attrs: { label: "狀態" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "請選擇狀態",
                  },
                  model: {
                    value: _vm.listQuery.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "status", $$v)
                    },
                    expression: "listQuery.status",
                  },
                },
                _vm._l(_vm.travelStatusOption, function (item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.checkPermission(["ITA-DEV", "ITA-ADMIN", "ITA-ADM-STAFF"])
            ? _c(
                "el-form-item",
                { attrs: { label: "旅客查詢" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "輸入旅客姓名" },
                    model: {
                      value: _vm.listQuery.memberQry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "memberQry", $$v)
                      },
                      expression: "listQuery.memberQry",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            attrs: {
              type: "warning",
              circle: "",
              icon: "el-icon-plus",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.addData },
          }),
          _c(
            "el-button",
            {
              attrs: { type: "danger", circle: "", disabled: _vm.listLoading },
              on: { click: _vm.editTravelInfoAnalyticsForm },
            },
            [_vm._v("AI")]
          ),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "項次",
                  width: "60",
                  fixed: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "團號",
                  width: "160",
                  fixed: "left",
                  fixed: _vm.device !== "mobile" ? "left" : null,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.tourGroupNo))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkPermission(["ITA-DEV", "ITA-ADMIN"])
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "團ID",
                      width: "50",
                      fixed: "left",
                      fixed: _vm.device !== "mobile" ? "left" : null,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_c("span", [_vm._v(_vm._s(scope.row.id))])]
                          },
                        },
                      ],
                      null,
                      false,
                      773642443
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "團名",
                  width: "200",
                  fixed: "left",
                  fixed: _vm.device !== "mobile" ? "left" : null,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [_vm._v(_vm._s(row.travelName))]),
                        _c("div", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-tag",
                                { staticStyle: { "font-size": "14px" } },
                                [
                                  _vm._v(" 出發 "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.beginDate + " " + row.beginTime
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" 回程 "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(row.endDate + " " + row.endTime)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTranslateStyle(scope.row.status),
                            },
                          },
                          [_vm._v(_vm._s(scope.row.statusDesc))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              !_vm.agencyCode
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "旅行社代碼",
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("span", [_vm._v(_vm._s(row.agencyCode))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3301007934
                    ),
                  })
                : _vm._e(),
              !_vm.agencyCode
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "旅行社名稱",
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("span", [_vm._v(_vm._s(row.agencyName))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3259265140
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.permissionCheck(scope.row.status)
                                ? "info"
                                : "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                "" +
                                  (_vm.permissionCheck(scope.row.status)
                                    ? "查看"
                                    : "編輯")
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.envMode != "production"
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "定位報到", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      color: "#409eff",
                                      "font-weight": "bold",
                                      "text-decoration": "none",
                                      cursor: "pointer",
                                      display: "block",
                                      "margin-bottom": "5px",
                                    },
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editCheckInPoint(row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 設定報到點 ")]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticStyle: {
                                      color: "#000000",
                                      "font-weight": "bold",
                                      "text-decoration": "none",
                                      cursor: "pointer",
                                      display: "block",
                                    },
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openCheckInHistory(row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 報到記錄 ")]
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3077067714
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "旅客設定", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-bottom": "5px" },
                                attrs: { size: "mini", plain: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editTravelers(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "旅客設定 " +
                                    _vm._s(
                                      scope.row.touristCount
                                        ? "(" + scope.row.touristCount + ")"
                                        : ""
                                    )
                                ),
                              ]
                            ),
                            !_vm.permissionCheck(scope.row.status)
                              ? _c("ocr-import-tourist-dialog", {
                                  attrs: {
                                    travelID: scope.row.id,
                                    tourGroupNo: scope.row.tourGroupNo,
                                  },
                                  on: { "import-success": _vm.getList },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "領隊設定", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.parseLeaderUserList(scope.row).length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  width: "100%",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "50%",
                                      display: "flex",
                                      "flex-direction": "column",
                                      "align-items": "center",
                                      "justify-content": "center",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm
                                        .parseLeaderUserList(scope.row)
                                        .slice(0, 3),
                                      function (leader, idx) {
                                        return _c(
                                          "span",
                                          {
                                            key: leader.id,
                                            staticStyle: {
                                              padding: "4px 0",
                                              "text-align": "center",
                                              cursor: "pointer",
                                              width: "100%",
                                              color: "#409eff",
                                              "font-weight": "600",
                                              "font-size": "14px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onViewLeader(
                                                  leader.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(leader.name) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm.parseLeaderUserList(scope.row).length >
                                    3
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              padding: "4px 0",
                                              "text-align": "center",
                                              width: "100%",
                                            },
                                          },
                                          [_vm._v("...")]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "50%",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.leaderSetting(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("設定")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  width: "100%",
                                  "align-items": "center",
                                  "justify-content": "center",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.leaderSetting(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("領隊設定")]
                                ),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "行程設定", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.getItineraryPlanningSetting(
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v("行程設定")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "座位設定", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "info", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.editSeatForms(scope.row)
                              },
                            },
                          },
                          [_vm._v("座位設定")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "攜帶物品", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "warning", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.getCarryItemsSetting(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 攜帶物品 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.envMode != "production"
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "小遊戲設定",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOpenTravelGameInfoDialog(
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 小遊戲設定 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      306015506
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "複製旅遊團", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.duplicateMultipleTravel(scope.row)
                              },
                            },
                          },
                          [_vm._v("複製")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkPermission(["ITA-DEV", "ITA-ADMIN", "ITA-ADM-STAFF"])
                ? _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "刪除旅遊團",
                      width: "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteTravel(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("刪除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      61762472
                    ),
                  })
                : _vm._e(),
              _vm.checkPermission([
                "ITA-DEV",
                "ITA-ADMIN",
                "SERVICE-ADMIN",
                "ITA-SALES",
              ])
                ? _c("el-table-column", {
                    attrs: {
                      prop: "description",
                      label: "日期登入",
                      width: "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: { type: "success", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.opLoginDateSetting(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("日期登入")]
                              ),
                              scope.row.useDateLogin && scope.row.loginDateStr
                                ? _c("el-tag", [
                                    _vm._v(_vm._s(scope.row.loginDateStr)),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      642568333
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { align: "center", label: "報名連結", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.signUpUrl && scope.row.status < 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "info" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openSignUpTravelDialog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("建立連結")]
                            )
                          : [
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    color: "#409eff",
                                    "text-decoration": "underline",
                                    display: "inline-block",
                                    "margin-bottom": "5px",
                                  },
                                  attrs: {
                                    href: scope.row.signUpUrl,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(scope.row.signUpUrl) + " "
                                  ),
                                ]
                              ),
                              _c("br"),
                              scope.row.status < 2
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "info" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openSignUpTravelDialog(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("編輯介紹")]
                                  )
                                : _vm._e(),
                            ],
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.outfitImageDialogVisible,
            top: "5%",
            width: "fit-content",
            "custom-class": "image-preview-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.outfitImageDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-image",
            {
              staticStyle: { height: "60vh" },
              attrs: {
                src: _vm.formData.outfitImageUrl,
                "preview-src-list": [_vm.formData.outfitImageUrl],
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-slot",
                  staticStyle: {
                    width: "24rem",
                    height: "60vh",
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                  },
                  attrs: { slot: "placeholder" },
                  slot: "placeholder",
                },
                [_c("i", { staticClass: "el-icon-loading" })]
              ),
              _c(
                "div",
                {
                  staticClass: "image-slot",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [_c("i", { staticClass: "el-icon-picture-outline" })]
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.outfitImageDialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }